import Datepicker from 'vuejs-datepicker';
import {
    Card,
    Button,
    Badge,
    InfoSection,
    FormGroupInput,
    Checkbox
}
from '@/components';
import {
    Select,
    Option,
    DatePicker
}
from 'element-ui'
import gql from 'graphql-tag';
import axios from 'axios';
import {
    customCellEditor
} from './tables/customCellEditor';
import "ag-grid-autocomplete-editor/dist/main.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import {
    AutocompleteSelectCellEditor
} from "ag-grid-autocomplete-editor";
import {
    AgGridVue
} from "ag-grid-vue";
import AddEntityModal from '../components/modals/AddEntityModal.vue'
import AddProceduresModal from '../components/modals/AddProceduresModal.vue'
import FileReader from "@/components/fileReader.vue";
import {
    mapState
} from 'vuex'
import {
    sqlTables
} from './tables'
import FormSchema, {
    Components
} from '@formschema/native'
import datePicker from '../components/customDatePicker.vue'
import customDialog from '../components/modals/customDialog.vue'
import Table from 'table-builder'
import {
    data
} from 'jquery';
var filterParams = {
    comparator: function(filterLocalDateAtMidnight, cellValue) {
        var dateAsString = cellValue;
        var dateParts = dateAsString.split('/');
        var cellDate = new Date(
            Number(dateParts[2]),
            Number(dateParts[1]) - 1,
            Number(dateParts[0])
        );
        if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
            return 0;
        }
        if (cellDate < filterLocalDateAtMidnight) {
            return -1;
        }
        if (cellDate > filterLocalDateAtMidnight) {
            return 1;
        }
    },
};

//graphql query imports

import GET_EXCAVATIONS_CITATIONS from "@/graphql/getExcavationsCitations"
import GET_ENTITYDBS from "@/graphql/getEntityDB"
import GET_ENTITYDBS_CD from "@/graphql/getEntityDB_CompanyDetails"
import GET_ENTITYDBS_LA from "@/graphql/EntityDB_LPAAmendments"
import GET_ENTITYDBS_RT from "@/graphql/getEntityDB_RegulatoryTax"
import GET_CASH_MANAGEMENT from "@/graphql/getCashManagement"
import GET_CASH_MANAGEMENT_BALANCE from "@/graphql/getCashManagementBalance"
import GET_EXCAVATIONS from "@/graphql/getExcavations"
import GET_ODDDBS from "@/graphql/getODD"

export default {
    name: 'home',
    bodyClass: 'tables',
    components: {
        Card,
        InfoSection,
        Badge,
        FileReader,
        customDialog,
        AgGridVue,
        AddEntityModal,
        AddProceduresModal,
        [Button.name]: Button,
        [Checkbox.name]: Checkbox,
        [FormGroupInput.name]: FormGroupInput,
        [Select.name]: Select,
        [Option.name]: Option,
        Datepicker,
    },
    data() {
        return {
            slides: (function() {
                var slides = [];
                for (var i = 0; i < 600; i += 1) {
                    slides.push('Slide ' + (i + 1));
                }
                return [...slides];
            }()),
            virtualData: {
                slides: []
            },
            startingBalance: null,
            disabledDates: {
                customPredictor: function(date) {
                    if (date.getUTCDate() != 1) {
                        return true
                    }
                }
            },
            refreshSave: 0,
            sortmodel: undefined,
            sorted: 0,
            drawersorted: 0,
            filereader: 0,
            modals: ['procedures'],
            rowsSelected: false,
            sheetChanged: false,
            deleteRows: false,
            rowsupdated: [],
            direction: 'ltr',
            currentRow: undefined,
            settings: {
                suppressScrollY: false,
                suppressScrollX: false,
            },
            drawer: false,
            mutations: {
                UPSERT_EXCAVATIONS: gql`mutation Update_hasuraExcavation($DealID: String!, $hasuraExcavation_set_input: hasuraExcavation_set_input) {
                                        update_hasuraExcavation_by_pk(pk_columns: {DealID: $DealID}, _set: $hasuraExcavation_set_input){
                                            DealID
                                        }
                                     }`,
                INSERT_EXCAVATIONS: gql`mutation Insert_hasuraExcavation($hasuraExcavation_insert_input: [hasuraExcavation_insert_input!]!) {
                                        insert_hasuraExcavation(objects: $hasuraExcavation_insert_input) {     
                                            affected_rows
                                            returning{
                                                DealID
                                            }   
                                        }
                                    }`,
                DELETE_EXCAVATIONS: gql`mutation Delete_hasuraExcavation($DealID: String!) {
                                        delete_hasuraExcavation_by_pk(DealID: $DealID) {
                                            DealID
                                        }
                                     }`,
                UPSERT_EXCAVATION_CITATIONS: gql`mutation Update_hasuraExcavationCitations($DealID: String!, $hasuraExcavationCitations_set_input: hasuraExcavationCitations_set_input) {
                                        update_hasuraExcavationCitations_by_pk(pk_columns: {DealID: $DealID}, _set: $hasuraExcavationCitations_set_input){
                                            DealID
                                        }
                                     }`,
                INSERT_AUDIT_LOG: gql`mutation InsertHasuraAudit($hasuraAudit_insert_input: [hasuraAudit_insert_input!]!) {
                                      insert_hasuraAudit(objects: $hasuraAudit_insert_input) {
                                        affected_rows
                                      }
                                    }`,
                INSERT_EXCAVATION_CITATIONS: gql`mutation Insert_hasuraExcavationCitations($hasuraExcavationCitations_insert_input: [hasuraExcavationCitations_insert_input!]!) {
                                        insert_hasuraExcavationCitations(objects: $hasuraExcavationCitations_insert_input) {     
                                            affected_rows
                                            returning{
                                                DealID
                                            }   
                                        }
                                    }`,
                DELETE_EXCAVATION_CITATIONS: gql`mutation Delete_hasuraExcavationCitations($DealID: String!) {
                                        delete_hasuraExcavationCitations_by_pk(DealID: $DealID) {
                                            DealID
                                        }
                                     }`,
                UPSERT_ENTITYDBS: gql`mutation UpsertEntityDB($data: String!) {
                                      upsertEntityDB(data: $data) {
                                      success
                                      }
                                     }`,
                DELETE_ENTITYDBS: gql`mutation DeleteEntityDB($data: String!) {
                                      deleteEntityDB(data: $data) {
                                      success
                                      }
                                     }`,
                UPSERT_ENTITYDBCDS: gql`mutation Update_EntityDB_CompanyDetails($CompanyName: String!, $EntityDB_CompanyDetails_set_input: EntityDB_CompanyDetails_set_input) {
                                        update_EntityDB_CompanyDetails_by_pk(pk_columns: {CompanyName: $CompanyName}, _set: $EntityDB_CompanyDetails_set_input){
                                            CompanyName
                                        }
                                    }`,
                UPSERT_ENTITYDBLAS: gql`mutation Update_EntityDB_LPAAmendments($CompanyName: String!, $EntityDB_LPAAmendments_set_input: EntityDB_LPAAmendments_set_input) {
                                        update_EntityDB_LPAAmendments_by_pk(pk_columns: {CompanyName: $CompanyName}, _set: $EntityDB_LPAAmendments_set_input){
                                            CompanyName
                                        }
                                    }`,
                UPSERT_ENTITYDBRTS: gql`mutation Update_EntityDB_RegulatoryTax($CompanyName: String!, $EntityDB_RegulatoryTax_set_input: EntityDB_RegulatoryTax_set_input) {
                                        update_EntityDB_RegulatoryTax_by_pk(pk_columns: {CompanyName: $CompanyName}, _set: $EntityDB_RegulatoryTax_set_input){
                                            CompanyName
                                        }
                                    }`,
                DELETE_ENTITYDBCDS: gql`mutation Delete_EntityDB_CompanyDetails($CompanyName: String!) {
                                        delete_EntityDB_CompanyDetails_by_pk(CompanyName: $CompanyName){
                                            CompanyName
                                        }
                                    }`,
                DELETE_ENTITYDBLAS: gql`mutation Delete_EntityDB_LPAAmendments($CompanyName: String!) {
                                        delete_EntityDB_LPAAmendments_by_pk(CompanyName: $CompanyName){
                                            CompanyName
                                        }
                                    }`,
                DELETE_ENTITYDBRTS: gql`mutation Delete_EntityDB_RegulatoryTax($CompanyName: String!) {
                                        delete_EntityDB_RegulatoryTax_by_pk(CompanyName: $CompanyName){
                                            CompanyName
                                        }
                                    }`,
                INSERT_ENTITYDBCDS: gql`mutation Insert_EntityDB_CompanyDetails($EntityDB_CompanyDetails_insert_input: [EntityDB_CompanyDetails_insert_input!]!) {
                                        insert_EntityDB_CompanyDetails(objects: $EntityDB_CompanyDetails_insert_input) {     
                                            affected_rows
                                            returning{
                                                CompanyName
                                            }   
                                        }
                                    }`,
                INSERT_ENTITYDBLAS: gql`mutation Insert_EntityDB_LPAAmendments($EntityDB_LPAAmendments_insert_input: [EntityDB_LPAAmendments_insert_input!]!) {
                                        insert_EntityDB_LPAAmendments(objects: $EntityDB_LPAAmendments_insert_input) {     
                                            affected_rows
                                            returning{
                                                CompanyName
                                            }   
                                        }
                                    }`,
                INSERT_ENTITYDBRTS: gql`mutation Insert_EntityDB_RegulatoryTax($EntityDB_RegulatoryTax_insert_input: [EntityDB_RegulatoryTax_insert_input!]!) {
                                        insert_EntityDB_RegulatoryTax(objects: $EntityDB_RegulatoryTax_insert_input) {     
                                            affected_rows
                                            returning{
                                                CompanyName
                                            }   
                                        }
                                    }`,
                UPSERT_AACPVIS: gql`mutation Update_CashManagement_cashManagement($Id: Int!, $CashManagement_cashManagement_set_input: CashManagement_cashManagement_set_input) {
                    update_CashManagement_cashManagement_by_pk(pk_columns: {Id: $Id}, _set: $CashManagement_cashManagement_set_input){
                        Id
                    }
                }`,
                DELETE_AACPVIS: gql`mutation Delete_CashManagement_AacpVI($Id: Int!) {
                                        delete_CashManagement_AacpVI_by_pk(Id: $Id){
                                            Id
                                        }
                                    }`,
                INSERT_AACPVIS: gql`mutation Insert_CashManagement_cashManagement($CashManagement_cashManagement_insert_input: [CashManagement_cashManagement_insert_input!]!) {
                    insert_CashManagement_cashManagement(objects: $CashManagement_cashManagement_insert_input) {     
                        affected_rows
                        returning{
                            Id
                        }   
                    }
                }`,
                UPSERT_AAFLIIIS: gql`mutation Update_CashManagement_cashManagement($Id: Int!, $CashManagement_cashManagement_set_input: CashManagement_cashManagement_set_input) {
                    update_CashManagement_cashManagement_by_pk(pk_columns: {Id: $Id}, _set: $CashManagement_cashManagement_set_input){
                        Id
                    }
                }`,
                DELETE_AAFLIIIS: gql`mutation Delete_CashManagement_AaflIII($Id: Int!) {
                                        delete_CashManagement_AaflIII_by_pk(Id: $Id){
                                            Id
                                        }
                                    }`,
                INSERT_AAFLIIIS: gql`mutation Insert_CashManagement_cashManagement($CashManagement_cashManagement_insert_input: [CashManagement_cashManagement_insert_input!]!) {
                    insert_CashManagement_cashManagement(objects: $CashManagement_cashManagement_insert_input) {     
                        affected_rows
                        returning{
                            Id
                        }   
                    }
                }`,
                UPSERT_IVORYIVS_old: gql`mutation Update_CashManagement_cashManagement($Id: Int!, $CashManagement_cashManagement_set_input: CashManagement_cashManagement_set_input) {
                    update_CashManagement_cashManagement_by_pk(pk_columns: {Id: $Id}, _set: $CashManagement_cashManagement_set_input){
                        Id
                    }
                }`,
                UPSERT_IVORYIVS: gql`mutation update_CashManagement_Transactions($Id: Int!, $CashManagement_Transactions_set_input: CashManagement_Transactions_set_input) {
  update_CashManagement_Transactions(where: {Id: {_eq: $Id}},_set: $CashManagement_Transactions_set_input) {
    returning {
      Deal
      BalSplit
      CoSplit
      FRBBalCkg
    }
  }
}`,
                DELETE_IVORYIVS: gql`mutation Delete_CashManagement_IvoryIV($Id: Int!) {
                                        delete_CashManagement_IvoryIV_by_pk(Id: $Id){
                                            Id
                                        }
                                    }`,
                INSERT_IVORYIVS: gql`mutation Insert_CashManagement_Transactions($CashManagement_Transactions_insert_input: [CashManagement_Transactions_insert_input!]!) {
                    insert_CashManagement_Transactions(objects: $CashManagement_Transactions_insert_input) {     
                        affected_rows
                        returning{
                            Id
                        }   
                    }
                }`,
                UPSERT_MDIVS: gql`mutation Update_CashManagement_cashManagement($Id: Int!, $CashManagement_cashManagement_set_input: CashManagement_cashManagement_set_input) {
                    update_CashManagement_cashManagement_by_pk(pk_columns: {Id: $Id}, _set: $CashManagement_cashManagement_set_input){
                        Id
                    }
                }`,
                DELETE_MDIVS: gql`mutation Delete_CashManagement_MdIV($Id: Int!) {
                                        delete_CashManagement_MdIV_by_pk(Id: $Id){
                                            Id
                                        }
                                    }`,
                INSERT_MDIVS: gql`mutation Insert_CashManagement_cashManagement($CashManagement_cashManagement_insert_input: [CashManagement_cashManagement_insert_input!]!) {
                    insert_CashManagement_cashManagement(objects: $CashManagement_cashManagement_insert_input) {     
                        affected_rows
                        returning{
                            Id
                        }   
                    }
                }`,
                UPSERT_CASHMANAGEMENTS: gql`mutation Update_CashManagement_cashManagement($Id: Int!, $CashManagement_cashManagement_set_input: CashManagement_cashManagement_set_input) {
                                        update_CashManagement_cashManagement_by_pk(pk_columns: {Id: $Id}, _set: $CashManagement_cashManagement_set_input){
                                            Id
                                        }
                                    }`,
                DELETE_CASHMANAGEMENTS_old: gql`mutation Delete_CashManagement_Transactions($Id: Int!) {
                                        delete_CashManagement_Transactions(where: {Id: { _eq: $Id}}){
                                        Id
                                        }
                                    }`,
                DELETE_CASHMANAGEMENTS: gql`mutation Delete_CashManagement_Transactions($Id: Int!) {
  delete_CashManagement_Transactions(where: {Id: {_eq: $Id}}) {
    returning {
      Id
    }
  }
}`,
                INSERT_CASHMANAGEMENTS: gql`mutation Insert_CashManagement_cashManagement($CashManagement_cashManagement_insert_input: [CashManagement_cashManagement_insert_input!]!) {
                                        insert_CashManagement_cashManagement(objects: $CashManagement_cashManagement_insert_input) {     
                                            affected_rows
                                            returning{
                                                Id
                                            }   
                                        }
                                    }`,
                UPSERT_ODDS: gql`mutation Update_odd_ODD($GPName: String!, $odd_ODD_set_input: odd_ODD_set_input) {
                                        update_odd_ODD_by_pk(pk_columns: {GPName: $GPName}, _set: $odd_ODD_set_input) {
                                            GPName
                                        }
                                    }`,
                DELETE_ODDS: gql`mutation Delete_odd_ODD($GPName: String!) {
                                        delete_odd_ODD_by_pk(GPName: $GPName) {
                                            GPName
                                        }
                                    }`,
                INSERT_ODDS: gql`mutation Insert_odd_ODD($odd_ODD_insert_input: [odd_ODD_insert_input!]!) {
                                        insert_odd_ODD(objects: $odd_ODD_insert_input) {
                                            affected_rows
                                            returning {
                                                GPName
                                            }
                                        }
                                    }`,
            },
            formstate: {},
            model: {},
            series: [],
            sheetChanges: [],
            auditLog: [],
            module: this.$store.getters.get('module') || 'Clients',
            subModule: this.$store.getters.get('subModule') || '',
            filteredData: this.setFilter && this.setFilter.selectedRows && this.setFilter.selectedRows.length > 0 ? this.setFilter.selectedRows : this.rowData ? this.rowData : [],
            columnLogic: { //custom logic for calculated columns
                WireDate: function(w, obj, data) {
                    obj.valueGetter = function(params) {
                        params.data.WireDate = params.data.WireDate ? params.data.WireDate : (new Date()).toISOString()
                        return params.data.WireDate
                    }
                    obj.valueSetter = function(params) {
                        var newValInt = (params.newValue);
                        var valueChanged = params.data.WireDate !== newValInt;
                        if (valueChanged) {
                            let wireDate
                            try {
                                wireDate = w.$moment.utc(newValInt).toISOString()
                                params.data.WireDate = wireDate
                                return newValInt
                            } catch (err) {
                                console.log(err)
                                return newValInt
                            }
                        } else {
                            return
                        }
                    }
                },
                FRBCoInvestCKG: function(w, obj, data) {
                    obj.editable = function(params) {
                        return params.data && params.data.Deal.toLowerCase().substr(0, 5) == 'cash ' ? false : true
                    }
                    obj.valueGetter = function(data) {
                        var dataFRB = data.data && data.data.Deal && typeof(data.data.Deal) == 'string' && data.data.Deal.toLowerCase().substr(0, 5) == 'cash ' && data.data.FRBBalancedCKG ? (-1 * data.data.FRBBalancedCKG) : data.data.FRBCoInvestCKG == null ? 0 : (data.data.FRBCoInvestCKG);
                        data.data.FRBCoInvestCKG = dataFRB
                        return w.handleNegetiveValue(dataFRB);
                    }
                },
                FRBBalancedCKG: function(w, obj, data) {
                    obj.valueGetter = function(data, obj) {
                        if (data.data && data.data.Deal && typeof(data.data.Deal) == 'string') {
                            let deal = data.data.Deal.toLowerCase()
                            if (deal.substr(0, 8).toLowerCase().includes('cash') && deal.toLowerCase().includes('transfer') && !data.data.BalSplit && !data.data.CoSplit) {
                                data.data.FRBBalancedCKG = w.getCellFormattedValue(data.data.FRBBalancedCKG);
                                return data.data.FRBBalancedCKG
                            } else if (deal.substr(0, 8).toLowerCase().includes('cash') && deal.toLowerCase().includes('transfer') && data.data.FRBBalancedCKG && (data.data.CoInvestCKG != data.data.FRBBalancedCKG)) {
                                if (typeof(data.data.FRBBalancedCKG) != 'number') {
                                    data.data.FRBBalancedCKG = parseFloat(data.data.FRBBalancedCKG.replace(/,/g, ''))
                                }
                                dataFRB = data.data.FRBBalancedCKG;
                            } else {
                                var dataFRB = deal.substr(0, 8).toLowerCase().includes('cash') && deal.toLowerCase().includes('transfer') && data.data.BalancedCKG ? data.data.BalancedCKG : deal.substr(0, 8).toLowerCase().includes('cash') && deal.toLowerCase().includes('transfer') && data.data.CoInvestCKG ? (1 * data.data.CoInvestCKG) : deal.substr(0, 5) == 'cash ' ? data.data.FRBBalancedCKG : deal.includes('loc repayment') && data.data.FRBBalCkg ? data.data.FRBBalCkg : data.data.FRBBalancedCKG == null ? (deal.includes('borrow from') ? data.data.FRBBalCkg : parseFloat(data.data.CoSplit || 0) + parseFloat(data.data.BalSplit || 0)) : data.data.FRBBalancedCKG;
                            }

                        } else {
                            return data.data.FRBBalancedCKG

                        }
                        data.data.FRBBalancedCKG = dataFRB
                        return w.handleNegetiveValue(dataFRB);
                    }
                },
                BalancedCKG: function(w, obj, data) {
                    obj.suppressNavigable = true;
                    obj.editable = function(params) {
                        return params.data && params.data.Deal.toLowerCase().substr(0, 5) == 'cash ' ? false : true
                    }
                    obj.valueSetter = function(params) {
                        var newValInt = (params.newValue);
                        var valueChanged = params.data.BalancedCKG !== newValInt;
                        if (valueChanged) {
                            params.data.BalSplit = newValInt;
                            return valueChanged;
                        } else {
                            var dataFRB = (data.data.FRBBalancedCKG == null || data.data.FRBBalancedCKG === undefined) ? 0 : w.handleNegetiveValue(data.data.FRBBalancedCKG);
                            var balanceCKG = dataFRB;
                            var itemdata = w.splitdata.filter(function(item) {
                                return item["iLevel Deal Name"] == data.data.Deal
                            });
                            if (itemdata && itemdata.length > 0) {
                                var total = itemdata.map(item => item["Deal Commitment"]).reduce((a, c) => {
                                    return a + c
                                });
                                itemdata.forEach(element => {
                                    const newValue = w.getCellFormattedValue(dataFRB);
                                    if (!element["Co-Investment Deal"]) {
                                        var p2 = ((element["Deal Commitment"] / total) * 100).toFixed(2);
                                        balanceCKG = w.handleNegetiveValue(parseFloat(newValue * p2 / 100).toFixed(2));
                                    }
                                }); +
                                0.00000001
                            }
                            return w.handleNegetiveValue(balanceCKG);
                        }
                    }
                    obj.valueGetter = function(data) {
                        if (data.data.BalSplit || data.data.BalSplit == 0) {
                            data.data.BalancedCKG = data.data.BalSplit
                            return w.handleNegetiveValue(data.data.BalSplit);
                        } else if (data.data.BalancedCKG || data.data.BalancedCKG == 0) {
                            return w.handleNegetiveValue(data.data.BalancedCKG);
                        } else {
                            if (data.data && data.data.Deal && typeof(data.data.Deal) == 'string' && data.data.Deal.toLowerCase().substr(0, 5) == 'cash ') {
                                return 0;
                            }
                            var dataFRB = (data.data.FRBBalancedCKG == null || data.data.FRBBalancedCKG === undefined) ? 0 : w.handleNegetiveValue(data.data.FRBBalancedCKG);
                            var balanceCKG = dataFRB;
                            var itemdata = w.splitdata.filter(function(item) {
                                return item["iLevel Deal Name"] == data.data.Deal
                            });
                            if (itemdata && itemdata.length > 0) {
                                var total = itemdata.map(item => item["Deal Commitment"]).reduce((a, c) => {
                                    return a + c
                                });
                                itemdata.forEach(element => {
                                    const newValue = w.getCellFormattedValue(dataFRB);
                                    if (!element["Co-Investment Deal"]) {
                                        var p2 = ((element["Deal Commitment"] / total) * 100).toFixed(2);
                                        balanceCKG = w.handleNegetiveValue(parseFloat(newValue * p2 / 100).toFixed(2));
                                    }
                                });
                            }
                            data.data.BalancedCKG = balanceCKG
                            let row = w.rowData.findIndex(x => x.Id == data.data.Id)
                            w.rowData[row].BalancedCKG = balanceCKG
                            return w.handleNegetiveValue(balanceCKG);
                        }
                    }

                },
                CoInvestCKG: function(w, obj, data) {
                    obj.suppressNavigable = true;
                    obj.editable = function(params) {
                        return params.data && params.data.Deal.toLowerCase().substr(0, 5) == 'cash ' ? false : true
                    }
                    obj.valueSetter = function(params) {
                        var newValInt = (params.newValue);
                        var valueChanged = params.data.CoInvestCKG !== newValInt;
                        if (valueChanged) {
                            params.data.CoSplit = newValInt;
                            return valueChanged;
                        } else {
                            var coInvestCKG = '0';
                            var itemdata = w.splitdata.filter(function(item) {
                                return item["iLevel Deal Name"] == data.data.Deal
                            });
                            var dataFRB = (data.data.FRBBalancedCKG == null || data.data.FRBBalancedCKG === undefined) ? 0 : w.handleNegetiveValue(data.data.FRBBalancedCKG);
                            if (itemdata && itemdata.length > 0) {
                                var total = itemdata.map(item => item["Deal Commitment"]).reduce((a, c) => {
                                    return a + c
                                });

                                itemdata.forEach(element => {
                                    const newValue = w.getCellFormattedValue(dataFRB);
                                    if (element["Co-Investment Deal"]) {
                                        var p1 = ((element["Deal Commitment"] / total) * 100).toFixed(2);
                                        coInvestCKG = w.handleNegetiveValue(parseFloat(newValue * p1 / 100).toFixed(2));
                                    }
                                });
                            }
                            return w.handleNegetiveValue(coInvestCKG);
                        }
                    }
                    obj.valueGetter = function(data) {
                        if (data.data.CoSplit || data.data.CoSplit == 0) {
                            data.data.CoInvestCKG = data.data.CoSplit
                            return w.handleNegetiveValue(data.data.CoSplit);
                        } else if (data.data.CoInvestCKG || data.data.CoInvestCKG == 0) {
                            return w.handleNegetiveValue(data.data.CoInvestCKG);
                        } else {
                            var coInvestCKG = '0';
                            var itemdata = w.splitdata.filter(function(item) {
                                return item["iLevel Deal Name"] == data.data.Deal
                            });
                            var dataFRB = (data.data.FRBBalancedCKG == null || data.data.FRBBalancedCKG === undefined) ? 0 : w.handleNegetiveValue(data.data.FRBBalancedCKG);
                            if (itemdata && itemdata.length > 0) {
                                var total = itemdata.map(item => item["Deal Commitment"]).reduce((a, c) => {
                                    return a + c
                                });

                                itemdata.forEach(element => {
                                    const newValue = w.getCellFormattedValue(dataFRB);
                                    if (element["Co-Investment Deal"]) {
                                        var p1 = ((element["Deal Commitment"] / total) * 100).toFixed(2);
                                        coInvestCKG = w.handleNegetiveValue(parseFloat(newValue * p1 / 100).toFixed(2));
                                    }
                                });
                            }
                            data.data.CoInvestCKG = coInvestCKG
                            let row = w.rowData.findIndex(x => x.Id == data.data.Id)
                            w.rowData[row].CoInvestCKG = coInvestCKG
                            return w.handleNegetiveValue(coInvestCKG);
                        }
                    }

                },
                AutomatedComments: function(w, obj, data) {
                    obj.valueGetter = function(data) {
                        var rowIndex = parseInt(data.node.id)
                        if (rowIndex && w.rowData[rowIndex]) {
                            var cashBalance = w.getCellFormattedValue(data.getValue('CashBalance'));
                            var todayDate = w.$moment.utc(new Date());
                            var wireDate = w.$moment.utc(data.getValue('WireDate'))
                            var dateDiff = todayDate.diff(wireDate, 'days');
                            var prevCashBalance = (rowIndex > 0) ? w.getCellFormattedValue(data.api.getRowNode(rowIndex - 1).data.CashBalance) : 0;;
                            var calculatedBalancedCKG = w.getCalculatedPrecashBalance(data, rowIndex);
                            var calculatedInvestranCoInvestCKG = w.getCellFormattedValue(data.getValue('FRBCoInvestTotal'));
                            var calculatedInvestranBalancedCKG = w.getCellFormattedValue(data.getValue('CKGBalance'));
                            var calculatedInvestranTrancheIICKG = w.getCellFormattedValue(data.getValue('RunningTranchIICKG'));
                            var calculatedBalTotal = w.getCellFormattedValue(data.getValue('FRBBalancedTotal'));
                            var balancedCKG = w.getCellFormattedValue(data.getValue('BalancedCKG'));
                            var absBalancedCKG = Math.abs(balancedCKG);
                            if ((dateDiff - 2 <= 1) && (calculatedBalancedCKG <= 0) && (prevCashBalance > absBalancedCKG)) {
                                data.data.AutomatedComments = 'Transfer cash now'
                                return 'Transfer cash now';
                            } else if (calculatedBalTotal < 0 || (cashBalance <= 0) || (calculatedInvestranBalancedCKG < 0) || (calculatedInvestranCoInvestCKG < 0) || (calculatedInvestranTrancheIICKG < 0)) {
                                data.data.AutomatedComments = 'Call capital now'
                                return 'Call capital now';
                            } else {
                                return '';
                            }
                        } else {
                            return null
                        }
                    }
                },
                RunningFRBCoCKG: function(w, obj, data) {
                    // This is the running total for the FRB Co-Investment Checking Account.
                    obj.valueGetter = function(data) {
                        var rowIndex = parseFloat(data.node.id)
                        if (rowIndex >= 0 && w.rowData[rowIndex]) {
                            var calcFRBBalancedCKG = w.getCellFormattedValue(data.getValue('FRBCoInvestCKG'))
                            var getRunningFRBCoCKG = (rowIndex > 0) ? w.getCellFormattedValue(data.api.getRowNode(rowIndex - 1).data.RunningFRBCoCKG) : w.getCellFormattedValue(w.balances && w.balances.CoInvestCKGBalance ? w.balances.CoInvestCKGBalance : 0);
                            const calcData = rowIndex == 0 ? w.handleNegetiveValue(getRunningFRBCoCKG + calcFRBBalancedCKG) : w.handleNegetiveValue(parseFloat(parseFloat(calcFRBBalancedCKG + getRunningFRBCoCKG).toFixed(2)));
                            w.rowData[rowIndex].RunningFRBCoCKG = calcData;
                            return calcData;
                        } else {
                            return null
                        }
                    }
                },
                CoInvestCKGBalance: function(w, obj, data) {
                    // This is the running total for the Co-Investment Reimbursement balance.  The name is misleading.
                    obj.valueGetter = function(data) {
                        var rowIndex = parseFloat(data.node.id)
                        if (rowIndex >= 0 && w.rowData[rowIndex]) {
                            var calcCoInvestCKG = w.getCellFormattedValue(data.getValue('CoInvestCKG'))
                            var getCoInvestCKGBalance = (rowIndex > 0) ? w.getCellFormattedValue(data.api.getRowNode(rowIndex - 1).data.CoInvestCKGBalance) : w.getCellFormattedValue(w.balances && w.balances.CoInvestReimburseBalance ? w.balances.CoInvestReimburseBalance : 0);
                            const calcData = rowIndex == 0 ? w.handleNegetiveValue(getCoInvestCKGBalance + calcCoInvestCKG) : w.handleNegetiveValue(parseFloat(parseFloat(getCoInvestCKGBalance + calcCoInvestCKG).toFixed(2)));
                            w.rowData[rowIndex].CoInvestCKGBalance = calcData;
                            return calcData;
                        } else {
                            return null
                        }
                    }
                },
                FRBBalancedTotal: function(w, obj, data) {
                    // This is the running total for the Investran Balanced Checking Account.  The name is misleading!!!
                    obj.valueGetter = function(data) {
                        var rowIndex = parseFloat(data.node.id)
                        let sum = w.getCellFormattedValue(w.balances && w.balances.BalancedTotal ? w.balances.BalancedTotal : 0);
                        w.gridApi.forEachNode(function(node) {
                            if (node.rowIndex <= rowIndex) {
                                sum = sum + (node.data.BalSplit ? w.cleanFloat(node.data.BalSplit) : 0)
                            }
                        })
                        data.data.FRBBalancedTotal = sum
                        return w.handleNegetiveValue(sum.toFixed(2))
                        //return w.handleNegetiveValue(data)
                    }
                },
                FRBCoInvestTotal: function(w, obj, data) {
                    // This is the running total for the Investran Co-Investment Checking Account.  The name is misleading!!!
                    obj.valueGetter = function(data) {
                        var rowIndex = parseFloat(data.node.id)
                        let sum = w.getCellFormattedValue(w.balances && w.balances.CoInvestTotal ? w.balances.CoInvestTotal : 0);
                        w.gridApi.forEachNode(function(node, i) {
                            if (node.rowIndex <= rowIndex) {
                                sum = sum + (node.data.CoSplit ? w.cleanFloat(node.data.CoSplit) : 0) + (node.data.FRBCoInvestCKG ? w.cleanFloat(node.data.FRBCoInvestCKG) : 0)
                            }
                        })
                        data.data.FRBCoInvestTotal = sum
                        return w.handleNegetiveValue(sum.toFixed(2))
                    }
                },
                RunningFRBBalCKG: function(w, obj, data) {
                    // This is the running total for the FRB Balanced Checking Account.
                    obj.valueGetter = function(data) {
                        var rowIndex = parseFloat(data.node.id)
                        if ((rowIndex >= 0) && w.rowData[rowIndex]) {
                            var calcFRBBalancedCKG = w.getCellFormattedValue(data.getValue('FRBBalancedCKG'))
                            var getRunningFRBBalCKG = (rowIndex > 0) ? w.getCellFormattedValue(data.api.getRowNode(rowIndex - 1).data.RunningFRBBalCKG) : w.getCellFormattedValue(w.balances && w.balances.CkgBalance ? w.balances.CkgBalance : 0);
                            const calcData = rowIndex == 0 ? w.handleNegetiveValue(getRunningFRBBalCKG + calcFRBBalancedCKG) : w.handleNegetiveValue(parseFloat(parseFloat(calcFRBBalancedCKG + getRunningFRBBalCKG).toFixed(2)));
                            w.rowData[rowIndex].RunningFRBBalCKG = calcData;
                            return calcData;
                        } else {
                            return null
                        }
                    }
                },
                CKGBalance: function(w, obj, data) {
                    // This is the Running Total for the Investran Balanced Checking Account.
                    obj.valueGetter = function(data) {
                        var rowIndex = parseFloat(data.node.id)
                        if (rowIndex >= 0 && w.rowData[rowIndex]) {
                            var calcBalancedCKGTotal = w.getCellFormattedValue(data.getValue('BalancedCKG'))
                            var getCKGBalance = (rowIndex > 0) ? w.getCellFormattedValue(data.api.getRowNode(rowIndex - 1).data.CKGBalance) : w.getCellFormattedValue(w.balances && w.balances.BalancedTotal ? w.balances.BalancedTotal : 0);
                            const calcData = rowIndex == 0 ? w.handleNegetiveValue(getCKGBalance + calcBalancedCKGTotal) : w.handleNegetiveValue(parseFloat(parseFloat(getCKGBalance + calcBalancedCKGTotal).toFixed(2)));
                            w.rowData[rowIndex].CKGBalance = calcData;
                            return calcData;
                        } else {
                            return null
                        }
                    }
                },
                CashBalance: function(w, obj, data) {
                    // This calculates the Running Cash Balance, including FRB Balanced, Co-Invest, and Tranche II Checking and MMA.
                    obj.valueGetter = function(data) {
                        var rowIndex = parseFloat(data.node.id)
                        if (rowIndex >= 0 && w.rowData[rowIndex]) {
                            var getCashBalance = w.getCellFormattedValue(data.getValue('FRBBalancedCKG')) + w.getCellFormattedValue(data.getValue('FRBCoInvestCKG')) + w.getCellFormattedValue(data.getValue('FRBTranchII')) + w.getCellFormattedValue(data.data.BalancedMMA) + w.getCellFormattedValue(data.data.CoInvestMMA)
                            var getRunningCashBalance = (rowIndex > 0) ? w.getCellFormattedValue(data.api.getRowNode(rowIndex - 1).data.CashBalance) : w.getCellFormattedValue(w.balances && w.balances.CashBalance ? w.balances.CashBalance : 0);
                            const calcData = rowIndex == 0 ? w.handleNegetiveValue(getRunningCashBalance + getCashBalance) : w.handleNegetiveValue(parseFloat(parseFloat(getRunningCashBalance + getCashBalance).toFixed(2)));
                            w.rowData[rowIndex].CashBalance = calcData;
                            return calcData;
                        } else {
                            return null
                        }
                    }
                },
                RunningTranchIICKG: function(w, obj, data) {
                    // This calculates the Investran balance for Tranche II (differentiated from the FRB balance).  It incorporates the Tranche II Split.
                    obj.valueGetter = function(data) {
                        var rowIndex = parseInt(data.node.id);
                        if (rowIndex && w.rowData[rowIndex]) {
                            var calcTranchIICKG = w.getCellFormattedValue(data.getValue('TranchIICKG')) + w.getCellFormattedValue(data.getValue('FRBTranchII'));
                            var getRunningTranchIICKG = (rowIndex > 0) ? w.getCellFormattedValue(data.api.getRowNode(rowIndex - 1).data.RuningTranchIICKG) : w.getCellFormattedValue(w.balances && w.balances.TrancheIITotal ? w.balances.TrancheIITotal : 0);
                            const calcData = rowIndex == 0 ? w.handleNegetiveValue(getRunningTranchIICKG + calcTranchIICKG) : w.handleNegetiveValue(parseFloat(parseFloat(getRunningTranchIICKG + calcTranchIICKG).toFixed(2)));
                            w.rowData[rowIndex].RunningTranchIICKG = calcData;
                            return calcData;
                        } else {
                            return null
                        }
                    }
                },
                RunningFRBTranchII: function(w, obj, data) {
                    obj.valueGetter = function(data) {
                        var rowIndex = parseInt(data.node.id);
                        if (rowIndex && w.rowData[rowIndex]) {
                            var FRBTranchII = w.getCellFormattedValue(data.data.FRBTranchII);
                            var preFRBTranchII = (rowIndex > 0) ? w.getCellFormattedValue(data.api.getRowNode(rowIndex - 1).data.RunningFRBTranchII) : w.getCellFormattedValue(w.balances && w.balances.TrancheIIBalance ? w.balances.TrancheIIBalance : 0);
                            const RunningFRBTranchII = rowIndex == 0 ? w.handleNegetiveValue(preFRBTranchII + FRBTranchII) : w.handleNegetiveValue(parseFloat(parseFloat(FRBTranchII + preFRBTranchII).toFixed(2)));
                            w.rowData[rowIndex].RunningFRBTranchII = RunningFRBTranchII;
                            return RunningFRBTranchII;
                        } else {
                            return null
                        }
                    }
                },
                Total: function(w, obj, data) {
                    obj.valueGetter = function(data) {
                        var rowIndex = parseInt(data.node.id);
                        if (typeof(rowIndex) != 'undefined' && w.rowData[rowIndex]) {
                            var calcFRBBalancedCKG = w.getCellFormattedValue(data.getValue('FRBBalancedCKG'))
                            var balanceMMA = w.getCellFormattedValue(data.data.BalancedMMA);
                            var coInvestMMA = w.getCellFormattedValue(data.data.CoInvestMMA);
                            var FRBCoInvestCKG = w.getCellFormattedValue(data.data.FRBCoInvestCKG);
                            var FRBTranchII = w.getCellFormattedValue(data.data.FRBTranchII);
                            let calcData = w.handleNegetiveValue(parseFloat(parseFloat(balanceMMA + coInvestMMA + calcFRBBalancedCKG + FRBCoInvestCKG + FRBTranchII).toFixed(2)))
                            w.rowData[rowIndex].Total = calcData;
                            return calcData;
                        } else {
                            return null
                        }
                    }
                }
            }
        }
    },
    apollo: {
        hasuraExcavation: {
            query: GET_EXCAVATIONS
        }
    },
    computed: {
        ...mapState({
            gqlmap: 'gqlmap',
            subgql: 'subgql',
            fund: 'fund',
            TrancheII: 'TrancheII',
            mma: 'mma',
            fundid: 'fundid',
            slideWrapper: 'slideWrapper'
        }),
        readyToSave: function() {
            let w = this;
            w.refreshSave;
            if (w.gqlmap == 'ivoryIv') {
                return w.sheetChanged && w.rowData.filter(x => !x.Deal || !x.WireDate).length == 0 ? true : false
            } else {
                return w.sheetChanged ? true : false
            }
        },
        slideStyles() {
            return `left: ${this.virtualData.offset}px;`;
        },
        slides2: function() {
            return this.filteredData;
        },
        keyfield: function() {
            return this.gqlmap === 'excavation' ? 'DealID' : (this.gqlmap === 'entitydb' || this.gqlmap === 'entitydbCd' || this.gqlmap === 'entitydbLa' || this.gqlmap === 'entitydbRt') ? 'CompanyName' : (this.gqlmap === 'aacpVi' || this.gqlmap === 'aafliii' || this.gqlmap === 'ivoryIv' || this.gqlmap === 'MDIv') ? 'Id' : (this.gqlmap === "odd") ? "GPName" : "FundName";
        },
        spinner: {
            get: function() {
                return this.$store.getters.get('spinner');
            },
            set: function(val) {
                this.$store.commit('change', {
                    spinner: val
                })
            }
        },
        TCD: {
            get: function() {
                return this.$store.getters.get('tcd');
            },
            set: function(val) {
                this.$store.commit('change', {
                    tcd: val
                })
            }
        },
        startdate: {
            get: function() {
                let w = this;
                let startdate = w.$store.getters.get('startdate')
                if (startdate) {
                    startdate = new Date(startdate);
                } else {
                    let date = new Date();
                    startdate = new Date(date.getFullYear(), date.getMonth(), 1);
                }
                return startdate
            },
            set: function(val) {
                let date = val.toISOString()
                let w = this;
                w.$store.commit('change', {
                    startdate: date
                })
            }
        },
        mapping: {
            get: function() {
                let w = this;
                return sqlTables[w.gqlmap] && sqlTables[w.gqlmap].mapping ? sqlTables[w.gqlmap].mapping : {}
            },
            set: function(val) {
                let w = this;
                sqlTables[w.gqlmap].mapping = val;
            }
        },
        aggregatedSeries: function() {
            let w = this;
            if (w.gqlmap && w.gqlmap == 'ivoryIv') {
                return w.series;
            }
            let mapping = sqlTables[w.gqlmap] ? sqlTables[w.gqlmap].mapping : {}
            let agg = {}
            if (w.series.length == 0) {
                return w.series
            } else {
                w.series.map((x, i) => {
                    let total = 0
                    let disc;
                    Object.keys(x).map(y => {
                        if (mapping[y] && mapping[y].sum && !isNaN(parseInt(x[y]))) total = total + parseInt(x[y])
                        if (mapping[y] && mapping[y].sum && x[y] && !isNaN(parseInt(x[y]))) {
                            agg[y] = agg[y] ? parseInt(agg[y]) + parseInt(x[y]) : parseInt(x[y])
                        } else {
                            agg[y] = null
                        }
                    })
                    agg['Calculated_Commitment'] = total
                    if (!isNaN(parseInt(x['Total__Commitment']))) agg['Discrepancy'] = agg['Total__Commitment'] - agg['Calculated_Commitment']
                })
            }
            agg.FundName = 'AGGREGATES'
            let seriesarray = []
            let series = [agg].concat(w.series);
            series.map(x => {
                let array = [];
                Object.keys(x).map(y => {
                    array.push({
                        key: y,
                        data: x[y]
                    })
                })
                seriesarray.push(array);
            })
            return series
        },
        appClass: {
            set: function(value) {
                this.$store.commit('change', {
                    appclass: value
                })
            },
            get: function(value) {
                return this.$store.getters.get('appclass')
            }
        },
        swiperOptions: function() {
            let w = this;
            let opts = {
                cssMode: true,
                allowTouchMove: false,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction'
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                virtual: {
                    slides: [...w.filteredData],
                    renderExternal(data) {
                        w.virtualData = data;
                    }
                }
            };
            return opts;
        },
        options: function() {
            let w = this;
            let slides = []
            let data = w.filteredData
            let mapping = sqlTables[this.gqlmap].mapping
            let citations = this.citations && Object.keys(this.citations).length > 0 ? this.citations : false;
            let opts = {
                cssMode: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction'
                },
                virtual: {
                    slides: slides
                }
            };
            return opts;
        },
        rowData: function() {
            let data = this.aggregatedSeries.filter(x => x[this.keyfield]).sort((a, b) => a.Id > b.Id ? 1 : -1)
            if (this.gqlmap == 'ivoryIv') {
                data = data.sort((a, b) => a.WireDate > b.WireDate ? 1 : a.WireDate < b.WireDate ? -1 : 0)
            }
            return data;
        },
        customDateFormat() {
            let MyDate = new Date()
            let MyDateString = ('0' + MyDate.getDate()).slice(-2) + ('0' + (MyDate.getMonth() + 1)).slice(-2) + MyDate.getFullYear().toString().substr(2, 4);
            return MyDateString;
        },
        sheet: function() {
            return false;
            var w = this;
            if (this.chartJSON) {
                var json = this.chartJSON;
                var rows = [];
                let components = JSON.parse(JSON.stringify(w.components))
                components.sort((a, b) => (a > b ? 1 : a < b ? -1 : 0))
                var columns = ['sample'].concat(components)
                rows.push(columns);
                json.forEach(function(p) {
                    var result = []
                    result.push(p.profile);
                    components.map((n) => {
                        var pct = p.result[n] ? p.result[n] : 0
                        result.push(pct)
                    })
                    rows.push(result)
                })
                return rows;
            } else {
                return null;
            }
        },
        columnDefs: function() {
            if (this.series && this.series.length > 0) {
                var columns = [];
                var comp = Object.keys(this.mapping)
                if (this.gqlmap === 'commitment') {
                    comp.sort((a, b) => this.mapping && this.mapping[a] && this.mapping[a].inserted ? 1 : -1)
                }
                var w = this;
                let meta = {},
                    pinned = [],
                    width = [],
                    immutable = {};
                var index = false;
                if (sqlTables[this.gqlmap]) {
                    meta = sqlTables[this.gqlmap]
                    pinned = sqlTables[this.gqlmap].pinned
                    width = sqlTables[this.gqlmap].width
                    immutable = sqlTables[this.gqlmap].immutable
                }
                let modcomp
                if (this.gqlmap == "ivoryIv") {
                    modcomp = []
                    if (this.TrancheII || this.mma) {
                        if (this.mma) {
                        console.log('mma', comp);
                            comp.map(x => {
                                if ((["Id", "Deal", "WireDate", "BalancedCKG", "CoInvestCKG", "Total", "CashBalance", "CKGBalance", "CoInvestCKGBalance", "AutomatedComments", "TiesToBank", "LOCInterestCommitment", "Notes", "FXRate", "FXRateDate"].includes(x) || x.toLowerCase().includes('frb') || x.toLowerCase().includes('mma')) && !x.toLowerCase().includes('tranch')) modcomp.push(x)
                            })
                        console.log('mma', modcomp);
                        } else {
                        console.log('trII 1', comp);
                            comp.map(x => {
                                if ((["Id", "Deal", "WireDate", "BalancedCKG", "CoInvestCKG", "Total", "CashBalance", "CKGBalance", "CoInvestCKGBalance", "AutomatedComments", "TiesToBank", "LOCInterestCommitment", "Notes", "FXRate", "FXRateDate"].includes(x) || x.toLowerCase().includes('frb') || x.toLowerCase().includes('trancheii') || x.toLowerCase().includes('trii')) && !x.toLowerCase().includes('mma')) {
                                    modcomp.push(x)
                                }
                            })
                        console.log('trII 2', modcomp);
                        }
                    } else {
                        let columns = ["Id", "Deal", "WireDate", "BalancedCKG", "CoInvestCKG", "Total", "CashBalance", "CKGBalance", "CoInvestCKGBalance", "AutomatedComments", "TiesToBank", "LOCInterestCommitment", "Notes", "FXRate", "FXRateDate"]
                        console.log('mapping', w.mapping);
                        //let extraCols = w.mapping.filter( x => x
                        comp.map(x => {
                            if (["Id", "Deal", "WireDate", "BalancedCKG", "CoInvestCKG", "Total", "CashBalance", "CKGBalance", "CoInvestCKGBalance", "AutomatedComments", "TiesToBank", "LOCInterestCommitment", "Notes", "FXRate", "FXRateDate"].includes(x) || (x.toLowerCase().includes('frb') && !x.toLowerCase().includes('tranch'))) modcomp.push(x)
                        })
                    }
                } else {
                    modcomp = comp;
                }
                modcomp.forEach(function(c, n) {
                    let checked = 0;
                    if (c !== 'id' && c !== '__typename' && c !== 'system_modified' && (w.mapping[c] && !w.mapping[c].hidden)) {
                        if (pinned.indexOf(c) >= 0) {
                            index = true;
                            var obj = {
                                headerName: w.mapping[c].header,
                                headerTooltip: w.mapping[c].header,
                                checkboxSelection: c == w.keyfield ? true : false,
                                field: c,
                                pinned: 'left',
                                tooltipField: c,
                                floatingFilter: true,
                                minWidth: width[c] ? width[c] : c.length > 6 ? 120 : c.length > 10 ? 180 : 80,
                                editable: immutable[c] ? false : true,
                                filter: true,
                                resizable: false,
                                rowDrag: false,
                                headerClass: 'header-sample',
                                cellStyle: {
                                    backgroundColor: '#f2f2f2',
                                    textTransform: 'uppercase',
                                    borderBottom: 'none',
                                    color: immutable[c] ? 'gray' : 'black',
                                    textAlign: c === 'DealID' ? 'center' : 'left',
                                    paddingRight: c === 'DealID' ? '10px' : '22px',
                                    fontSize: '10px'
                                },
                            }
                        } else {
                            var obj = {};
                            obj.editable = immutable[c] ? false : true,
                                obj.floatingFilter = true;
                            obj.tooltipField = c;
                            obj.minWidth = width[c] ? width[c] : c.length > 6 ? 120 : c.length > 10 ? 180 : 100,
                                obj.headerName = w.mapping[c] && w.mapping[c].header ? w.mapping[c].header : (c.charAt(0).toUpperCase() + c.slice(1)).replace(/_/g, ' ');
                            obj.headerTooltip = obj.headerName;

                            if (c.endsWith('Date') || w.mapping[c] && w.mapping[c].dataType == 'date') {
                                obj.headerName = obj.headerName.replace(/date/, ' Date');
                                obj.valueFormatter = function(data) {
                                    if (data.value && Date.parse(data.value) > 0) {
                                        return w.handledateFormatter(w.$moment.utc(data.value).format('L'))
                                    }
                                }
                                obj.cellEditor = customCellEditor;
                                obj.filterParams = {
                                    buttons: ['reset'],
                                    comparator: (filterLocalDateAtMidnight, cellValue) => {
                                        const dateAsString = cellValue;
                                        if (dateAsString == null || Date.parse(dateAsString) <= 0) {
                                            return 0;
                                        }
                                        const dateParts = dateAsString.split('/');
                                        const day = Number(dateParts[2]);
                                        const month = Number(dateParts[1]) - 1;
                                        const year = Number(dateParts[0]);
                                        const cellDate = new Date(year, month, day);

                                        if (cellDate < filterLocalDateAtMidnight) {
                                            return -1;
                                        } else if (cellDate > filterLocalDateAtMidnight) {
                                            return 1;
                                        }
                                        return 0;
                                    }
                                }
                            } else {
                                if (c == 'BalancedCKG' || c == 'CoInvestCKG') {
                                    obj.cellClass = 'sandy'
                                }
                                obj.headerClass = w.mapping[c] && w.mapping[c].inserted ? 'header-inserted' : '';
                                obj.cellEditor = w.mapping[c] && w.mapping[c].cellEditor === "agTextCellEditor" ? customCellEditor : (w.mapping[c].cellEditor === "autoCompleteCellEditor") ? AutocompleteSelectCellEditor : 'agLargeTextCellEditor';
                                if (w.mapping[c] && w.mapping[c].cellEditor === "autoCompleteCellEditor") {
                                    obj.valueFormatter = function(params) {
                                        if (params.value) {
                                            return params.value.label || params.value.value || params.value;
                                        }
                                        return "";
                                    };
                                    obj.cellEditorParams = {
                                        required: true,
                                        autocomplete: {
                                            strict: false,
                                            autoselectfirst: true,
                                            onFreeTextSelect: function(value) {},
                                        },
                                        selectData: w.selectedData,
                                        placeholder: "Select an option"
                                    }

                                } else {
                                    obj.cellEditorParams = {
                                        maxLength: 8000
                                    };
                                }
                            }

                            if (w.columnLogic && w.columnLogic[c]) {
                                // if any custom logic is needed for calculated columns, create a custom function to handle it
                                w.columnLogic[c](w, obj, data);
                            }
                            if (w.mapping[c] && w.mapping[c].type === 'commitment') {
                                obj.cellStyle = {
                                    backgroundColor: 'brown',
                                };
                            }
                            obj.field = c;
                            obj.resizable = true,
                                obj.filter = obj.filter ? obj.filter : true;
                            obj.cellStyle = function(data) {
                                if (data.data.rowModfied) {}
                                return {
                                    textAlign: c.endsWith('Date') ? 'center' : w.mapping[c].textAlign === 'right' ? 'right' : 'left',
                                    paddingLeft: '10px',
                                    paddingRight: '10px',
                                    background: immutable[c] ? '#c5daf155' : 'transparent'
                                }
                            };
                        }
                        obj.filterParams = obj.filterParams ? obj.filterParams : {
                            buttons: ['reset']
                        }
                        obj.sortable = true;
                        obj.cellRenderer = w.mapping[c] && w.mapping[c].dataType && w[`render${w.mapping[c].dataType}`] ? w[`render${w.mapping[c].dataType}`] : null
                        obj.valueFormatter = function(data) {
                            if (data && data.value && w.mapping[c] && w.mapping[c].dataType === 'number' && !isNaN(parseInt(data.value)) && c != w.keyfield) {
                                let value = parseInt(data.value).toFixed(0);
                                var formatted = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                if (parseInt(data.value) < 0) formatted = `(${formatted.replace(/-/, '')})`
                                if (parseInt(data.value) == 0 || isNaN(parseInt(data.value))) {
                                    formatted = '-'
                                } else {}
                                return formatted
                            }
                            if (c.endsWith('Date') || w.mapping[c] && w.mapping[c].dataType == 'date') {
                                obj.headerName = obj.headerName.replace(/date/, ' Date');
                                if (data.value && Date.parse(data.value) > 0) {
                                    return w.handledateFormatter(w.$moment.utc(data.value).format('L'))
                                } else {
                                    data.value = 0;
                                    return ""
                                }
                            }
                            if (data && data.value && w.mapping[c] && w.mapping[c].dataType === 'percent' && !isNaN(parseInt(data.value))) {
                                return (parseFloat(data.value) * 100).toFixed(2) + '%'
                            }
                        }
                        if (w.mapping[c] && w.mapping[c].cellEditor === "autoCompleteCellEditor") {
                            obj.valueFormatter = function(params) {
                                if (params.value) {
                                    return params.value.label || params.value.value || params.value;
                                }
                                return "";
                            };
                        }
                        columns.push(obj);
                    }
                }) //yousef
                let newcolumns = []
                columns.map(x => {
                    let c = x.field;
                    if (w.mapping[c] && w.mapping[c].type === 'commitment' && w.mapping[c].inserted) newcolumns.push(x)
                })
                columns.map(x => {
                    let c = x.field;
                    if (w.mapping[c] && w.mapping[c].type === 'commitment' && !w.mapping[c].inserted) newcolumns.push(x)
                })
                columns.map(x => {
                    let c = x.field;
                    if (w.mapping[c] && w.mapping[c].type !== 'commitment') newcolumns.push(x)
                })
                console.log('cols', columns);
                return newcolumns
            } else {
                var columns = null;
                return columns;
            }
        },
    },
    watch: {
        $route(to, from) {
            this.setModule()
            this.runQuery();
        }
    },
    beforeMount() {
        this.frameworkComponents = {
            agDateInput: datePicker
        };
        let w = this;
        this.gridOptions = {
            headerHeight: 80,
            tooltipShowDelay: 5,
            suppressScrollOnNewData: false,
            cellFlashDelay: 500000000,
            rowClassRules: {
                'modified': function(params) {
                    return params.data.system_modified === true || params.data['FundName'] === 'aAGGREGATES';
                },
                'aggregated': function(params) {
                    return params.data['FundName'] === 'AGGREGATES';
                },
            },
            enableBrowserTooltips: false,
            animateRows: false,
            defaultColDef: {
                flex: 1,
                minWidth: 150,
                suppressClickEdit: true,
                filter: true
            },
            pagination: this.$route && this.$route.name == 'CashManagement' ? false : true,
            paginationPageSize: 20,
            onFirstDataRendered: function(params) {},
            onModelUpdated: function(params) {
                setTimeout(function() {
                    params.api.sizeColumnsToFit();
                })
            },
            onGridReady: function(params) {
                window.addEventListener('resize', function() {
                    setTimeout(function() {
                        params.api.sizeColumnsToFit();
                    })
                })
            },
        }
    },
    created() {
        this.agcomponents = {};
    },
    mounted() {
        console.log('map', this.gqlmap);
        this.splitdata = []
        this.dataChanges = []
        this.dataChangeDB = []
        this.rowsupdated = []
        this.deleteRows = false;
        this.citations = {}
        this.drawersorted = Date.now()
        this.sorted = Date.now()
        this.filereader = Date.now()
        this.runQuery(true)
        this.selectedData = [];
        this.getSplitData();
    },
    methods: {
        changeStartDate() {
            this.$nextTick(() => {
                let date = this.$store.getters.get('startdate')
                if (date) {
                    date = date.split('T')[0]
                    this.runQuery(true)
                }
            })
        },
        createAggregates(data) {
            let series = data;
            series.map((row, i) => {

            })
        },
        cleanFloat(value) {
            if (value) {
                if (typeof(value) == 'number') {
                    return value;
                } else {
                    value = value.replace(/,/g, '').replace(/\(/, '-').replace(/\)/, '')
                    return isNaN(value) ? null : parseFloat(value)
                }
            } else {
                return null
            }
        },
        getSplitData() {
            let w = this;
            var data = JSON.stringify({
                "FundID": "222"
            });

            var config = {
                method: 'post',
                url: 'https://asiaaltfunctions.azurewebsites.net/api/querySplits?code=hgG_DtbepOvlh2l-Ep01sYMOMyZkSUsqnQDZHSDgVRgZAzFuX5Uz-A==',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };

            axios(config)
                .then(function(response) {
                    w.splitdata = response.data;
                    const uniqueData = w.getUniqueListBy(response.data, 'iLevel Deal Name');
                    uniqueData.forEach(element => {
                        w.selectedData.push({
                            value: element['iLevel Deal Name'],
                            label: element['iLevel Deal Name']
                        })
                    });
                    w.selectedData.push({
                        value: "Cash Transfer",
                        label: "Cash Transfer"
                    })
                    w.selectedData.push({
                        value: "Cash Settlement",
                        label: "Cash Settlement"
                    })
                })
                .catch(function(error) {
                    console.log(error);
                });

        },
        getUniqueListBy(arr, key) {
            return [...new Map(arr.map(item => [item[key], item])).values()]
        },
        log(evt) {
            let w = this;
            if (evt == 'drawer') {
                if (w.savedState) {
                    w.gridOptions.api.setFilterModel();
                }
                if (w.filterState) {
                    w.gridOptions.api.setFilterModel(w.filterState);
                }
            }
        },
        beforeCloseDrawer(done) {
            return done(true)
        },
        getCellFormattedValue(value) {
            if (value === undefined || value == "" || value === null || value == '(NaN)') {
                return 0;
            } else {
                var regExp = /\(([^)]+)\)/;
                value = value.toString().replace(/,/g, '');
                var match = regExp.exec(value);
                var data = (match === null) ? value : '-' + match[1];
                var result = parseFloat(parseFloat(data).toFixed(2));
                return result;
            }
        },
        handleNegetiveValue(value) {
            value = value == null ? "0" : value.toString().replace(")", "").replace("(", "-");
            value = value.toString().replace(/,/g, '');
            value = parseFloat(value).toFixed(2);
            var result = parseFloat(value) >= 0 ? parseFloat(value).toFixed(2) : '(' + parseFloat((Math.abs(value))).toFixed(2) + ')';
            return result.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            //.replace(/\.00/, '');
        },
        handledateFormatter(value) {
            var date = new Date(value);
            const formattedData = (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear());
            return formattedData;
        },
        getCalculatedPrecashBalance(data, rowIndex) {
            let w = this;
            //var rowIndex = 0; //parseInt(data.node.id);
            let calculateBalance = 0;
            if (rowIndex > 0) {
                for (var i = rowIndex; i >= 0; i--) {
                    calculateBalance = calculateBalance + w.getCellFormattedValue(data.api.getRowNode(i).data.BalancedCKG);
                }
            }
            return calculateBalance;
        },
        getCalculatedPrecashBalanceFromEvent(data, event) {
            let w = this;
            var rowIndex = event.rowIndex; //parseInt(data.node.id);
            let calculateBalance = 0;
            if (rowIndex > 0) {
                for (var i = rowIndex; i >= 0; i--) {
                    calculateBalance = calculateBalance + w.getCellFormattedValue(event.api.getRowNode(i).data.BalancedCKG);
                }
            }
            return calculateBalance;
        },
        getCalculatedPrecashBalanceOnLoad(data) {
            let w = this;
            var rowIndex = data.length - 1;
            let calculateBalance = 0;
            if (rowIndex > 0) {
                for (var i = rowIndex; i >= 0; i--) {
                    calculateBalance = calculateBalance + w.getCellFormattedValue(data[i].BalancedCKG);
                }
            }
            return calculateBalance;
        },

        getDatePicker() {
            function Datepicker() {
                datePicker.prototype.init = function(params) {
                    this.eInput = document.createElement("input");
                    this.eInput.setAttribute("type", "date");
                    this.cell = params.eGridCell;
                    this.oldWidth = this.cell.style.width;
                    this.cell.style.width = "162px";
                    this.eInput.value = params.value;
                };
                datePicker.prototype.getGui = function() {
                    return this.eInput;
                };
                datePicker.prototype.afterGuiAttached = function() {
                    this.eInput.focus();
                    this.eInput.select();
                };
                datePicker.prototype.getValue = function() {
                    this.cell.style.width = this.oldWidth;
                    return this.eInput.value;
                };
                datePicker.prototype.destroy = function() {};
                datePicker.prototype.isPopup = function() {
                    return false;
                };
            }
            return Datepicker;
        },
        scrollHandle(evt) {},
        resetChanges: function() {
            let w = this;
            let buttons = [{
                    title: 'Reset',
                    handler: () => {
                        w.setFilter = undefined
                        w.rowsupdated = [];
                        w.gridApi.deselectAll();
                        w.gridApi.flashCells({
                            rowNodes: []
                        })
                        w.$modal.hide('dialog');
                        setTimeout(() => {
                            w.dataChanges = [];
                            w.sheetChanges = [];
                            w.auditLog = [];
                            w.sheetChanged = false;
                            w.runQuery(true);
                        }, 100)
                    }
                },

                {
                    title: 'Cancel',
                    default: true,
                    handler: () => {
                        w.$modal.hide('dialog');
                    }
                }
            ]
            this.$modal.show('dialog', {
                title: 'Are you sure?',
                width: '600px',
                maxHeight: '600px',
                text: 'You have unsaved changes, these will be lost if you reset',
                class: 'warning',
                buttons: buttons
            })
        },
        deleteSelection: function() {
            let w = this;
            let rowsSelected = [...this.gridApi.getSelectedRows()];
            rowsSelected = rowsSelected.map(x => x[w.keyfield]).filter(x => x !== undefined)
            let buttons = [{
                    title: 'Delete',
                    handler: () => {
                        let data = []
                        let user = w.$store.getters.get('user')
                        user = user && user.username ? user.username : 'unknown'
                        rowsSelected.map(x => {
                            let obj = {}
                            obj[w.keyfield] = x;
                            obj.action = 'delete';
                            obj.audit = {
                                user: user,
                                key: w.keyfield,
                                old: x,
                                new: 'deleted',
                                timestamp: Date.now()
                            }
                            data.push(obj);
                            this.deleteSQLData(obj);
                            if (this.gqlmap === 'excavation') {
                                this.deleteSQLData(obj, 'citation');
                            }
                        })

                        w.$modal.hide('dialog');
                    }
                },

                {
                    title: 'Cancel',
                    default: true,
                    handler: () => {
                        w.$modal.hide('dialog');
                    }
                }
            ]
            this.$modal.show('dialog', {
                title: 'Caution!',
                width: '600px',
                maxHeight: '600px',
                text: `Deletes are not reversible, ` + (rowsSelected.length > 1 ? `these (${rowsSelected.length}) records` : 'this record') + ` will be removed permanently`,
                class: 'failure',
                buttons: buttons
            })
        },
        updateCitation: function(key, field, value) {
            let w = this;
            let update = function() {
                let rowindex = w.rowData.findIndex(z => z[w.keyfield] == key)
                let rowNode = w.gridApi.getRowNode(rowindex)
                if (w.rowsupdated.findIndex(x => x.rowIndex == rowNode.rowIndex) < 0) {
                    w.rowsupdated.push(rowNode);
                }
                w.gridApi.flashCells({
                    rowNodes: w.rowsupdated
                })
                w.gridApi.deselectAll();
                let name = 'Citation > ' + key
                let user = w.$store.getters.get('user')
                user = user && user.username ? user.username : 'unknown'
                let oldValue = w.citations[key][field]
                let audit = {
                    user: user,
                    key: key,
                    old: oldValue ? oldValue : 'Empty',
                    new: value,
                    timestamp: Date.now()
                }
                let change = `<p class='dialog-text'>${name} > ${field}<br/><i style='color:brown'>${oldValue ? oldValue : 'Empty'}</i><br/><i style='color:#016e99'>${value}</i></p>`
                if (w.citations[key] && w.citations[key][field]) {
                    if (w.sheetChanges.findIndex(x => x === change) < 0) {
                        value = value == null || value == undefined || value == '' ? '-' : value
                        w.citations[key][field] = value;
                        if (w.dataChanges.findIndex(x => x.dataType === 'citation' && x[w.keyfield] == key) >= 0) {
                            let index = w.dataChanges.findIndex(x => x.dataType === 'citation' && x[w.keyfield] == key)
                            w.citations[key].dataType = 'citation'
                            w.dataChanges[index] = w.citations[key]
                            w.auditLog.push(audit)
                            w.sheetChanges.push(change)
                            w.sheetChanged = true;
                        } else {
                            w.citations[key].dataType = 'citation'
                            w.dataChanges.push(w.citations[key])
                            w.auditLog.push(audit)
                            w.sheetChanges.push(change)
                            w.sheetChanged = true;
                        }
                    } else {
                        let sheetindex = w.sheetChanges.findIndex(x => x === change)
                        value = value == null || value == undefined || value == '' ? '-' : value
                        w.citations[key][field] = value;
                        if (w.dataChanges.findIndex(x => x.dataType === 'citation' && x[w.keyfield] == key) >= 0) {
                            let index = w.dataChanges.findIndex(x => x.dataType === 'citation' && x[w.keyfield] == key)
                            w.citations[key].dataType = 'citation'
                            w.dataChanges[index] = w.citations[key]
                            w.auditLog.push(audit)
                            w.sheetChanges[sheetindex] = change
                            w.sheetChanged = true;
                        } else {
                            w.citations[key].dataType = 'citation'
                            w.dataChanges.push(w.citations[key])
                            w.auditLog.push(audit)
                            w.sheetChanges[sheetindex] = change
                            w.sheetChanged = true;
                        }

                    }
                }
            }
            clearTimeout(w.debounce)
            w.debounce = setTimeout(() => {
                update()
            }, 1000)
        },
        updateRow: function(field, value, key, oldValue) {
            let w = this;
            let index = w.filteredData.findIndex(z => z[w.keyfield] == key)
            if (field && key && (value != oldValue)) {
                let update = function() {
                    let rowindex = w.filteredData.findIndex(z => z[w.keyfield] == key)
                    if (rowindex >= 0) {
                        let data = w.rowData[rowindex]
                        data.rowIndex = rowindex
                        let rowNode = w.gridApi.getDisplayedRowAtIndex(rowindex)
                        if (w.rowsupdated.findIndex(x => x.rowIndex == rowNode.rowIndex) < 0) {
                            w.rowsupdated.push(rowNode);
                        }
                        let name = w.series[rowindex][w.keyfield]
                        let user = w.$store.getters.get('user')
                        user = user && user.username ? user.username : 'unknown'
                        let audit = {
                            user: user,
                            key: data[w.keyfield],
                            old: oldValue ? oldValue : 'Empty',
                            new: value,
                            timestamp: Date.now()
                        }
                        let change = `<p class='dialog-text'>${name} > ${field}<br/><i style='color:brown'>${oldValue ? oldValue : 'Empty'}</i><br/><i style='color:#016e99'>${value}</i></p>`
                        if (w.sheetChanges.findIndex(x => x === change) < 0) {
                            if (w.dataChanges.findIndex(x => x.rowIndex == data.rowIndex) >= 0) w.dataChanges.splice(w.dataChanges.findIndex(x => x.rowIndex == data.rowIndex), 1)
                            w.dataChanges.push(data)
                            w.auditLog.push(audit)
                            w.sheetChanges.push(change)
                            w.sheetChanged = true;
                        }
                        w.gridApi.flashCells({
                            rowNodes: w.rowsupdated
                        })
                        w.gridApi.deselectAll();
                    }
                }
                update()
            }
        },
        setFormat: function(key, field, val) {
            let w = this;
            let index = w.filteredData && w.filteredData[0] ? w.filteredData.findIndex(z => z[w.keyfield] == key) : false
            let value = val
            let oldVal = w.filteredData[index][field]
            if (index >= 0 && (oldVal !== value)) {
                let type = w.mapping[field] && w.mapping[field].dataType ? w.mapping[field].dataType : field.indexOf('Date') >= 0 ? 'date' : 'text'
                value = value && type == 'number' ? value.toString().replace(/,/g, '') : value
                clearTimeout(w.debounce);
                w.debounce = setTimeout(() => {
                    let id = w.rowData.findIndex(x => x[w.keyfield] == key)
                    let rowNode = w.gridOptions.api.getRowNode(id);
                    if (rowNode) {
                        let testval = rowNode.data[field]
                        if (testval !== value) {
                            rowNode.setDataValue(field, value);
                        }
                    }
                }, type == 'date' ? 2000 : 1000)
            }
        },
        fieldFormatter: function(key, field, val) {
            let w = this;
            let type = w.mapping[field] && w.mapping[field].dataType ? w.mapping[field].dataType : field.indexOf('Date') >= 0 ? 'date' : 'text'
            const formatters = {
                date: function(val, field) {
                    if (Date.parse(val) >= 0) {
                        let date = new Date(val);
                        let formattedDate = w.handledateFormatter(w.$moment.utc(val).format('L'));
                        formattedDate = formattedDate.split('/')
                        formattedDate = [formattedDate[2], formattedDate[0], formattedDate[1]].join('-')
                        if (date.getFullYear() == '1969') {
                            return ''
                        } else {
                            return formattedDate
                        }
                    } else {
                        return ''
                    }
                },
                percenta: function(val) {
                    let pct = !isNaN(parseFloat(val)) ? (100 * parseFloat(val)).toFixed(2) + '%' : val
                    return pct
                },
                text: function(val) {
                    return val
                },
                number: function(val, field) {
                    let value = val ? parseInt(val.toString().replace(/,/g, '')).toFixed(0) : val
                    var formatted = field == w.keyfield ? val : value ? value.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : val
                    if (!isNaN(parseInt(val)) && parseInt(val) < 0) formatted = `(${formatted.replace(/-/, '')})`
                    if (parseInt(val) == 0 || isNaN(parseInt(val))) {
                        formatted = '-'
                    } else {}
                    return formatted
                },
                currency: function(val) {
                    return val
                },
            }
            if (formatters[type]) {
                return formatters[type](val, field)
            } else {
                return val
            }
        },
        debounce2: function(func, wait, timeout) {
            var timeout;
            return function() {
                var context = this,
                    args = arguments;
                var later = function() {
                    timeout = null;
                    if (!immediate) {
                        func.apply(context, args);
                    }
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) {
                    func.apply(context, args);
                }
            };
        },
        loadTextFromFile(ev) {
            const file = ev.target.files[0];
            const reader = new FileReader();
            reader.onload = e => {
                console.log(e);
            }
            reader.readAsArrayBuffer(file);
        },
        getEntitydbs: async function() {
            let queryEntity = GET_ENTITYDBS;
            if (gqlmap == 'entitydbCd') {
                queryEntity = GET_ENTITYDBS_CD;
            } else if (gqlmap == 'entitydbLa') {
                queryEntity = GET_ENTITYDBS_LA;
            }
            this.$adal.acquireToken('6e0cdae3-9345-4b51-aa10-8d00a3512389', async (err, token) => {
                let data = await this.$apollo.query({
                    query: queryEntity,
                    fetchPolicy: 'network-only'
                })
                return (data ? data : {
                    data: {
                        data: {
                            entitydb: []
                        }
                    }
                })
            })
        },
        getOdddbs: async function() {
            let queryOddDb = GET_ODDDBS;

            this.$adal.acquireToken(
                "6e0cdae3-9345-4b51-aa10-8d00a3512389",
                async (err, token) => {
                    let data = await this.$apollo.query({
                        query: queryOddDb,
                        fetchPolicy: "network-only",
                    });
                    return data ?
                        data : {
                            data: {
                                data: {
                                    odddb: [],
                                },
                            },
                        };
                }
            );
        },
        getCashManagements: async function() {
            let queryCashManagement = GET_CASH_MANAGEMENT;
            this.$adal.acquireToken('6e0cdae3-9345-4b51-aa10-8d00a3512389', async (err, token) => {
                let data = await this.$apollo.query({
                    query: queryCashManagement,
                    fetchPolicy: 'network-only'
                })
                return (data ? data : {
                    data: {
                        data: {
                            cashManagement: []
                        }
                    }
                })
            })
        },
        getExcavations: async function() {
            this.$adal.acquireToken('6e0cdae3-9345-4b51-aa10-8d00a3512389', async (err, token) => {
                let data = await this.$apollo.query({
                    query: GET_EXCAVATIONS,
                    fetchPolicy: 'network-only'
                })
                return (data ? data : {
                    data: {
                        data: {
                            excavation: []
                        }
                    }
                })
            })
        },
        async deleteSQLData(data, dataType) {
            let w = this;
            w.spinner = true
            try {
                let obj = {}
                data = JSON.parse(JSON.stringify(data));
                //let results = [...data.map(x => x.DealID)]
                //let json = JSON.stringify(data);
                let query = dataType === 'citation' ? this.mutations['DELETE_EXCAVATION_CITATIONS'] : this.gqlmap == "excavation" ? this.mutations["DELETE_EXCAVATIONS"] : this.mutations['DELETE_CASHMANAGEMENTS']
                console.log('deleting', data, dataType, this.gqlmap, query.definitions[0].name);
                let variableData = {};
                if (this.gqlmap == "entitydbCd") {
                    variableData = {
                        CompanyName: data.CompanyName
                    }
                } else if (this.gqlmap == "entitydbLa") {
                    variableData = {
                        CompanyName: data.CompanyName
                    }
                } else if (this.gqlmap == "entitydbRt") {
                    variableData = {
                        CompanyName: data.CompanyName
                    }
                } else if (this.gqlmap == "aacpVi") {
                    variableData = {
                        Id: data.Id
                    }
                } else if (this.gqlmap == "aafliii") {
                    variableData = {
                        Id: data.Id
                    }
                } else if (this.gqlmap == "ivoryIv") {
                    variableData = {
                        Id: data.Id
                    }
                } else if (this.gqlmap == "MDIv") {
                    variableData = {
                        Id: data.Id
                    }
                } else if (this.gqlmap == "odd") {
                    variableData = {
                        GPName: data.GPName
                    }
                } else if (this.gqlmap == "excavation") {
                    variableData = {
                        DealID: data.DealID
                    }
                }
                if ((this.gqlmap != "excavation" && variableData.Id == null) || (this.gqlmap == "excavation" && !variableData.DealID)) {

                    w.spinner = false;
                    //w.rowData.pop();

                    this.gridApi = this.gridOptions.api;
                    //this.gridApi.applyTransaction({ remove: [data] });
                    this.gridApi.rowData = w.rowData.pop();
                    this.gridApi.refreshCells();
                    this.gridApi.redrawRows();

                } else {
                    console.log('Audit Log', data.audit)
                    if ( data.audit || this.auditLog.length ) {
                    data.audit = data.audit || this.auditLog
                    try {
                    let auditData = {}
                    auditData.DealID = variableData.DealID ? variableData.DealID : variableData.Id ? variableData.Id : variableData.CompanyName ? variableData.CompanyName : variableData.GPName ? variableData.variableData : null
                    auditData.Timestamp = parseInt(data.audit.timestamp/1000);
                    auditData.username = data.audit.user ||  data.audit.username
                    auditData.dataset = this.gqlmap;
                    auditData.event = `${data.action} ${data.audit.old} -> ${data.audit.new}`
                    console.log(auditData);
                    let audit = await this.$apollo.mutate({ mutation: this.mutations['INSERT_AUDIT_LOG'], variables: { hasuraAudit_insert_input:  auditData} })
                    console.log(audit);
                    }
                    catch(err) {
                    console.log(err)
                    }
                    }
                     w.spinner = false;
                    this.$apollo.mutate({
                            mutation: query,
                            variables: variableData
                        })
                        .then(res => {
                            w.spinner = false;
                            if (res) {
                                if (res && res.data && Object.keys(res.data) && res.data[Object.keys(res.data)[0]]) {
                                    this.sheetChanges = [];
                                    this.gridApi.flashCells({
                                        rowNodes: []
                                    })
                                    this.gridApi.deselectAll();
                                    this.runQuery(true);
                                    this.$modal.show('dialog', {
                                        title: 'Success!',
                                        text: 'Deletes sucessfully applied',
                                    })
                                } else {
                                    console.log('result', res.data);
                                    this.$modal.show('dialog', {
                                        title: 'Error!',
                                        text: 'Deletes not applied',
                                        class: 'failure'
                                    })
                                }
                            }
                        })
                        .catch(err => {
                            w.spinner = false;
                            this.$modal.show('dialog', {
                                title: 'Error!',
                                text: err,
                                class: 'failure'
                            })
                        })
                }
            } catch (err) {
                w.spinner = false;
                this.$modal.show('dialog', {
                    title: 'Error!',
                    text: err,
                    class: 'failure'
                })
            }
        },
        async upsertSQLDataCitation(data) {
            let w = this;
            w.spinner = true
            try {
                let obj = {}
                if (this.auditLog && this.auditLog.length > 0) {
                    this.auditLog.map(x => {
                        obj[x.key] = x
                    })
                }
                data = JSON.parse(JSON.stringify(data));
                delete data.__typename;
                delete data.dataType;
                delete data.system_modified;
                delete data.system_inserted;
                // data.map(x => {
                //     if (x[this.keyfield] && obj[x[this.keyfield]]) x.audit = obj[x[this.keyfield]]
                // })
                let json = JSON.stringify(data);
                let query = this.mutations['UPSERT_EXCAVATION_CITATIONS']
                let variableData = {};
                if (this.gqlmap == "excavation") {
                    variableData = {
                        DealID: data.DealID,
                        hasuraExcavationCitations_set_input: data
                    }
                }
                console.log('hasuraExcavationCitations', data.DealID);
                    console.log('Audit Log', data.audit)
                    if ( data.audit ) {
                    try {
                    let auditData = {}
                    auditData.DealID = variableData.DealID ? variableData.DealID : variableData.Id ? variableData.Id : variableData.CompanyName ? variableData.CompanyName : variableData.GPName ? variableData.variableData : null
                    auditData.Timestamp = parseInt(data.audit.timestamp/1000);
                    auditData.username = data.audit.user ||  data.audit.username
                    auditData.dataset = this.gqlmap;
                    auditData.event = `${data.action} ${data.audit.old} -> ${data.audit.new}`
                    console.log(auditData);
                    let audit = await this.$apollo.mutate({ mutation: this.mutations['INSERT_AUDIT_LOG'], variables: { hasuraAudit_insert_input:  auditData} })
                    console.log(audit);
                    }
                    catch(err) {
                    console.log(err)
                    }
                    }
                this.$apollo.mutate({
                        mutation: query,
                        variables: variableData
                    })
                    .then(res => {
                        w.spinner = false;
                        if (res) {
                            if (res && res.data && Object.keys(res.data) && res.data[Object.keys(res.data)[0]]) {
                                this.dataChanges = [];
                                this.rowsupdated = [];
                                this.sheetChanges = [];
                                this.gridApi.flashCells({
                                    rowNodes: []
                                })
                                this.gridApi.deselectAll();
                                this.auditLog = [];
                                this.sheetChanged = false;
                                this.runQuery(true);
                                this.$modal.show('dialog', {
                                    title: 'Success!',
                                    text: 'Updates sucessfully applied',
                                })
                            } else {
                                this.$modal.show('dialog', {
                                    title: 'Error!',
                                    text: 'Updates not applied<br/>',
                                    class: 'failure'
                                })
                            }
                        }
                    })
                    .catch(err => {
                        w.spinner = false;
                        this.$modal.show('dialog', {
                            title: 'Error!',
                            text: err,
                            class: 'failure'
                        })
                    })
            } catch (err) {
                w.spinner = false;
                this.$modal.show('dialog', {
                    title: 'Error!',
                    text: err,
                    class: 'failure'
                })
            }
        },
        async upsertSQLData(data) {
            let w = this;
            w.spinner = true
            try {
                let obj = {}
                if (this.auditLog && this.auditLog.length > 0) {
                    this.auditLog.map(x => {
                        obj[x.key] = x
                    })
                }
                data = JSON.parse(JSON.stringify(data));
                delete data.__typename;
                delete data.system_modified;
                delete data.system_inserted;
                // data.map(x => {
                //     if (x[this.keyfield] && obj[x[this.keyfield]]) x.audit = obj[x[this.keyfield]]
                // })
                let json = JSON.stringify(data);
                let query = this.mutations[`UPSERT_${this.gqlmap.toUpperCase()}S`]
                let variableData = {};
                if (this.gqlmap == "entitydbCd") {
                    variableData = {
                        CompanyName: data.CompanyName,
                        EntityDB_CompanyDetails_set_input: data
                    }
                } else if (this.gqlmap == "entitydbLa") {
                    variableData = {
                        CompanyName: data.CompanyName,
                        EntityDB_LPAAmendments_set_input: data
                    }
                } else if (this.gqlmap == "entitydbRt") {
                    variableData = {
                        CompanyName: data.CompanyName,
                        EntityDB_RegulatoryTax_set_input: data
                    }
                } else if (this.gqlmap == "excavation") {
                    variableData = {
                        DealID: data.DealID,
                        hasuraExcavation_set_input: data
                    }
                } else if (this.gqlmap == "aacpVi") {
                    var Id = data.Id;
                    delete data.Id;
                    variableData = {
                        Id: Id,
                        CashManagement_cashManagement_set_input: data
                    }
                } else if (this.gqlmap == "aafliii") {
                    var Id = data.Id;
                    delete data.Id;
                    variableData = {
                        Id: Id,
                        CashManagement_cashManagement_set_input: data
                    }
                } else if (this.gqlmap == "ivoryIv") {
                    var Id = data.Id;
                    const filterData = {
                        "Deal": data.Deal,
                        CoSplit: this.cleanFloat(data.CoInvestCKG),
                        BalSplit: this.cleanFloat(data.BalancedCKG),
                        "FundId": this.fundid,
                        "FRBBalCkg": this.cleanFloat(data.FRBBalancedCKG),
                        "FRBCoInvestCKG": this.cleanFloat(data.FRBCoInvestCKG),
                        "WireDate": data.WireDate.split('T')[0],
                        "Notes": data.Notes,
                        "FXRate": data.FXRate,
                        "FXRateDate": data.FXRateDate,
                    };
                    variableData = {
                        Id: Id,
                        CashManagement_Transactions_set_input: filterData
                    }
                    console.log('saving', variableData)
                } else if (this.gqlmap == "MDIv") {
                    var Id = data.Id;
                    delete data.Id;
                    variableData = {
                        Id: Id,
                        CashManagement_cashManagement_set_input: data
                    }
                } else if (this.gqlmap == "odd") {
                    variableData = {
                        GPName: data.GPName,
                        odd_ODD_set_input: data,
                    }
                }
                console.log('update', variableData)
                    console.log('Audit Log', data.audit)
                    if ( data.audit ) {
                    try {
                    let auditData = {}
                    auditData.DealID = variableData.DealID ? variableData.DealID : variableData.Id ? variableData.Id : variableData.CompanyName ? variableData.CompanyName : variableData.GPName ? variableData.variableData : null
                    auditData.Timestamp = parseInt(data.audit.timestamp/1000);
                    auditData.username = data.audit.user ||  data.audit.username
                    auditData.dataset = this.gqlmap;
                    auditData.event = `${data.action} ${data.audit.old} -> ${data.audit.new}`
                    console.log(auditData);
                    let audit = await this.$apollo.mutate({ mutation: this.mutations['INSERT_AUDIT_LOG'], variables: { hasuraAudit_insert_input:  auditData} })
                    console.log(audit);
                    }
                    catch(err) {
                    console.log(err)
                    }
                    }
                this.$apollo.mutate({
                        mutation: query,
                        variables: variableData
                    })
                    .then(res => {
                        w.spinner = false;
                        if (res) {
                            console.log('res', res);
                            if (res && res.data && Object.keys(res.data) && res.data[Object.keys(res.data)[0]]) {
                                this.dataChanges = [];
                                this.rowsupdated = [];
                                this.sheetChanges = [];
                                this.gridApi.flashCells({
                                    rowNodes: []
                                })
                                this.gridApi.deselectAll();
                                this.auditLog = [];
                                this.sheetChanged = false;
                                this.runQuery(true);
                                this.$modal.show('dialog', {
                                    title: 'Success!',
                                    text: 'Updates sucessfully applied',
                                })
                            } else {
                                this.$modal.show('dialog', {
                                    title: 'Error!',
                                    text: 'Updates not applied<br/>',
                                    class: 'failure'
                                })
                            }
                        }
                    })
                    .catch(err => {
                        console.log('Error!', err);
                        w.spinner = false;
                        this.$modal.show('dialog', {
                            title: 'Error!',
                            text: err,
                            class: 'failure'
                        })
                    })
            } catch (err) {
                w.spinner = false;
                this.$modal.show('dialog', {
                    title: 'Error!',
                    text: err,
                    class: 'failure'
                })
            }
        },
        async insertSQlDataCitation(data) {
            let w = this;
            try {
                let obj = {}
                if (this.auditLog && this.auditLog.length > 0) {
                    this.auditLog.map(x => {
                        obj[x.key] = x
                    })
                }
                data = JSON.parse(JSON.stringify(data));
                delete data.__typename;
                delete data.system_modified;
                delete data.system_inserted;
                let json = JSON.stringify(data);
                let query = this.mutations['INSERT_EXCAVATION_CITATIONS']
                let variableData = {};
                if (this.gqlmap == "excavation") {
                    delete data.dataType;
                    variableData = {
                        hasuraExcavationCitations_insert_input: data
                    }
                }
                    console.log('Audit Log', data.audit)
                    if ( data.audit ) {
                    try {
                    let auditData = {}
                    auditData.DealID = variableData.DealID ? variableData.DealID : variableData.Id ? variableData.Id : variableData.CompanyName ? variableData.CompanyName : variableData.GPName ? variableData.variableData : null
                    auditData.Timestamp = parseInt(data.audit.timestamp/1000);
                    auditData.username = data.audit.user ||  data.audit.username
                    auditData.dataset = this.gqlmap;
                    auditData.event = `${data.action} ${data.audit.old} -> ${data.audit.new}`
                    console.log(auditData);
                    let audit = await this.$apollo.mutate({ mutation: this.mutations['INSERT_AUDIT_LOG'], variables: { hasuraAudit_insert_input:  auditData} })
                    console.log(audit);
                    }
                    catch(err) {
                    console.log(err)
                    }
                    }

                this.$apollo.mutate({
                        mutation: query,
                        variables: variableData
                    })
                    .then(res => {
                        w.spinner = false;
                        if (res) {
                            if (res && res.data && Object.keys(res.data) && res.data[Object.keys(res.data)[0]]) {
                                this.sheetChanges = [];
                                this.gridApi.flashCells({
                                    rowNodes: []
                                })
                                this.gridApi.deselectAll();
                                this.auditLog = [];
                                this.sheetChanged = false;
                                this.runQuery(true);
                            } else {
                                this.$modal.show('dialog', {
                                    title: 'Error!',
                                    text: 'Updates not applied<br/>',
                                    class: 'failure'
                                })
                            }
                        }
                    })
                    .catch(err => {
                        w.spinner = false;
                        this.$modal.show('dialog', {
                            title: 'Error!',
                            text: err,
                            class: 'failure'
                        })
                    })
            } catch (err) {
                w.spinner = false;
                this.$modal.show('dialog', {
                    title: 'Error!',
                    text: err,
                    class: 'failure'
                })
            }
        },
        async insertSQLData(data) {
            let w = this;
            w.spinner = true
            try {
                let obj = {}
                if (this.auditLog && this.auditLog.length > 0) {
                    this.auditLog.map(x => {
                        obj[x.key] = x
                    })
                }
                data = JSON.parse(JSON.stringify(data));
                delete data.__typename;
                delete data.system_modified;
                delete data.system_inserted;
                let json = JSON.stringify(data);
                let query = this.mutations[`INSERT_${this.gqlmap.toUpperCase()}S`]
                let variableData = {};
                if (this.gqlmap == "entitydbCd") {
                    variableData = {
                        EntityDB_CompanyDetails_insert_input: data
                    }
                } else if (this.gqlmap == "entitydbLa") {
                    variableData = {
                        EntityDB_LPAAmendments_insert_input: data
                    }
                } else if (this.gqlmap == "entitydbRt") {
                    variableData = {
                        EntityDB_RegulatoryTax_insert_input: data
                    }
                } else if (this.gqlmap == "excavation") {
                    variableData = {
                        hasuraExcavation_insert_input: data
                    }
                } else if (this.gqlmap == "aacpVi") {
                    delete data.Id;
                    data.FundId = "102";
                    variableData = {
                        CashManagement_cashManagement_insert_input: data
                    }
                } else if (this.gqlmap == "aafliii") {
                    delete data.Id;
                    data.FundId = "218";
                    variableData = {
                        CashManagement_cashManagement_insert_input: data
                    }
                } else if (this.gqlmap == "ivoryIv") {
                    delete data.Id;
                    data.FundId = this.fundid;
                    const filterData = {
                        "Deal": data.Deal,
                        CoSplit: this.cleanFloat(data.CoInvestCKG),
                        BalSplit: this.cleanFloat(data.BalancedCKG),
                        "FundId": this.fundid,
                        "FRBBalCkg": this.cleanFloat(data.FRBBalancedCKG),
                        "FRBCoInvestCKG": this.cleanFloat(data.FRBCoInvestCKG),
                        "WireDate": data.WireDate.split('T')[0],
                        "Notes": data.Notes,
                        "FXRate": data.FXRate,
                        "FXRateDate": data.FXRateDate,
                    };
                    variableData = {
                        CashManagement_Transactions_insert_input: filterData
                    }
                } else if (this.gqlmap == "MDIv") {
                    delete data.Id;
                    data.FundId = "174";
                    variableData = {
                        CashManagement_cashManagement_insert_input: data
                    }
                } else if (this.gqlmap == "odd") {
                    variableData = {
                        odd_ODD_insert_input: data
                    }
                }
                    console.log('Audit Log', data.audit)
                    if ( data.audit || this.auditLog.length ) {
                    data.audit = data.audit || this.auditLog
                    try {
                    let auditData = {}
                    auditData.DealID = variableData.DealID ? variableData.DealID : variableData.Id ? variableData.Id : variableData.CompanyName ? variableData.CompanyName : variableData.GPName ? variableData.variableData : null
                    auditData.Timestamp = parseInt(data.audit.timestamp/1000);
                    auditData.username = data.audit.user ||  data.audit.username
                    auditData.dataset = this.gqlmap;
                    auditData.event = `${data.action} ${data.audit.old} -> ${data.audit.new}`
                    console.log(auditData);
                    let audit = await this.$apollo.mutate({ mutation: this.mutations['INSERT_AUDIT_LOG'], variables: { hasuraAudit_insert_input:  auditData} })
                    console.log(audit);
                    }
                    catch(err) {
                    console.log(err)
                    }
                    }

                this.$apollo.mutate({
                        mutation: query,
                        variables: variableData
                    })
                    .then(res => {
                        w.spinner = false;
                        if (res) {
                            if (res && res.data && Object.keys(res.data) && res.data[Object.keys(res.data)[0]]) {
                                this.dataChanges = [];
                                this.rowsupdated = [];
                                this.sheetChanges = [];
                                this.gridApi.flashCells({
                                    rowNodes: []
                                })
                                this.gridApi.deselectAll();
                                this.auditLog = [];
                                this.sheetChanged = false;
                                this.runQuery(true);
                                console.log("data after post", this.gqlmap, data);
                                const entityData = ["entitydbCd", "entitydbLa", "entitydbRt"]
                                if (entityData.includes(this.gqlmap)) {
                                    entityData.forEach((item) => {
                                        if (this.gqlmap !== item) {
                                            this.addEmptyEntityTable(item, data.CompanyName);
                                        }
                                    });
                                }
                                this.$modal.show('dialog', {
                                    title: 'Success!',
                                    text: 'Updates sucessfully applied',
                                })
                            } else {
                                this.$modal.show('dialog', {
                                    title: 'Error!',
                                    text: 'Updates not applied<br/>',
                                    class: 'failure'
                                })
                            }
                        }
                    })
                    .catch(err => {
                        w.spinner = false;
                        this.$modal.show('dialog', {
                            title: 'Error!',
                            text: err,
                            class: 'failure'
                        })
                    })
            } catch (err) {
                w.spinner = false;
                this.$modal.show('dialog', {
                    title: 'Error!',
                    text: err,
                    class: 'failure'
                })
            }
        },
        async addEmptyEntityTable(tableName, companyName) {
            var w = this;
            console.log(tableName, companyName);
            let mappingData =
                sqlTables[tableName] && sqlTables[tableName].mapping ?
                sqlTables[tableName].mapping : {};
            let fields = Object.keys(mappingData);
            var columnName = fields.map((x) => mappingData[x].col);

            var prepareData = {};
            columnName.forEach((item) => {
                prepareData[item] = (item == "CompanyName") ? companyName : "";
            });

            console.log("prepareData", prepareData);

            let query = this.mutations[`INSERT_${tableName.toUpperCase()}S`];
            let variableData = {};
            if (tableName == "entitydbCd") {
                variableData = {
                    EntityDB_CompanyDetails_insert_input: prepareData
                }
            } else if (tableName == "entitydbLa") {
                variableData = {
                    EntityDB_LPAAmendments_insert_input: prepareData
                }
            } else if (tableName == "entitydbRt") {
                variableData = {
                    EntityDB_RegulatoryTax_insert_input: prepareData
                }
            }
                    console.log('Audit Log', data.audit)
                    if ( data.audit ) {
                    try {
                    let auditData = {}
                    auditData.DealID = variableData.DealID ? variableData.DealID : variableData.Id ? variableData.Id : variableData.CompanyName ? variableData.CompanyName : variableData.GPName ? variableData.variableData : null
                    auditData.Timestamp = parseInt(data.audit.timestamp/1000);
                    auditData.username = data.audit.user ||  data.audit.username
                    auditData.dataset = this.gqlmap;
                    auditData.event = `${data.action} ${data.audit.old} -> ${data.audit.new}`
                    console.log(auditData);
                    let audit = await this.$apollo.mutate({ mutation: this.mutations['INSERT_AUDIT_LOG'], variables: { hasuraAudit_insert_input:  auditData} })
                    console.log(audit);
                    }
                    catch(err) {
                    console.log(err)
                    }
                    }

            this.$apollo.mutate({
                    mutation: query,
                    variables: variableData
                })
                .then(res => {
                    w.spinner = false;
                    if (res) {
                        if (res && res.data && Object.keys(res.data) && res.data[Object.keys(res.data)[0]]) {
                            console.log("updated successfully", tableName);
                        } else {
                            this.$modal.show('dialog', {
                                title: 'Error!',
                                text: 'Updates not applied<br/>',
                                class: 'failure'
                            })
                        }
                    }
                })
                .catch(err => {
                    w.spinner = false;
                    this.$modal.show('dialog', {
                        title: 'Error!',
                        text: err,
                        class: 'failure'
                    })
                })
        },
        addFund() {
            let mapping = sqlTables && sqlTables[this.gqlmap] && sqlTables[this.gqlmap].mapping ? sqlTables[this.gqlmap].mapping : {}
            mapping = JSON.parse(JSON.stringify(mapping))
            let w = this;
            let defaultName = ''
            let buttons = [{
                    title: 'OK',
                    handler: () => {
                        let input = document.getElementById('nameDialog')
                        defaultName = input.value
                        let column = input.value.replace(/ /g, '_')
                        this.mapping[column] = {
                            column: column,
                            dataType: 'currency',
                            header: defaultName,
                            sum: true,
                            type: 'commitment',
                            inserted: true
                        }
                        let series = JSON.parse(JSON.stringify(this.series))
                        series = series.map(x => {
                            x[column] = 0;
                            return x
                        })
                        this.series = series;
                        w.$modal.hide('customDialog');
                        setTimeout(() => {
                            let index = this.columnDefs.findIndex(x => x.field == column)
                            if (index >= 0) {
                                let allColumns = this.gridOptions.columnApi.getAllColumns();
                                let column = allColumns[index];
                                if (column) {
                                    this.gridOptions.api.ensureColumnVisible(column);
                                }
                            }
                        }, 0)

                    }
                },
                {
                    title: 'Cancel',
                    default: true,
                    handler: () => {
                        w.closable = false;
                        w.$modal.hide('customDialog');
                    }
                }
            ]
            w.$modal.show('customDialog', {
                title: 'Fund Name',
                text: `<input id="nameDialog" autofocus autocomplete="off" spellcheck="false" value=${'"' + defaultName + '"'}>`,
                class: undefined,
                buttons: buttons
            })
        },
        dateFormat(value) {
            return (new Date(value)).toLocaleDateString()
        },
        loadSheet: async function(evt) {
            try {
                let w = this;
                let rows = []
                let data = new Uint8Array(evt);
                if (data && data.length) {
                    let workbook = await XLSX.read(data, {
                        type: 'array'
                    });
                    let json = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]])
                    if (json && json[0].Term) {
                        let map = {}
                        let reversemap = {}
                        let fields = Object.keys(this.mapping)
                        let columns = fields.map(x => this.mapping[x].header)
                        columns.map((x, i) => {
                            map[x] = fields[i]
                            reversemap[fields[i]] = x;
                        })
                        let value = {}
                        json.map(x => {
                            value[x.Term.replace(/\n/g, '').replace(/\r/g, '')] = x.Value
                        })
                        let sources = {};
                        let citation = {};
                        if (this.gqlmap === 'excavation') {
                            json.map(x => {
                                if (x.Citation) {
                                    citation[x.Term] = x.Citation.toString();
                                } else {
                                    citation[x.Term] = '-';
                                }
                            })
                        }
                        citation['DealID'] = value['Deal_ID'] ? value['Deal_ID'] : value['Deal ID'] ? value['Deal ID'] : value['DealID'] ? value['DealID'] : value['Deal_ID'] ? value['Deal_ID'] : '-'
                        citation['Deal ID'] = citation['DealID'].toString();
                        let row = {}
                        Object.keys(value).map((y, n) => {
                            y = y.replace(/\n/g, '').replace(/\r/g, '')
                            let key = map[y] ? map[y] : y.replace(/ /g, '_').replace(/-/g, '_').replace(/\#/g, '').replace(/\,/g, '').replace(/^20/, 'Y20').replace(/\(/g, '').replace(/\)/g, '').replace(/Fund_Name/, 'FundName')
                            key = key == 'Deal_ID' ? 'DealID' : key;
                            if (w.series[0] && fields.findIndex(z => z == key) < 0) {
                                console.log(key + ' is missing')
                            } else {
                                //console.log(key, value[y]);
                            }
                            value[y] = (value[y] === undefined) ? null : value[y].toString();
                            if (!isNaN(value[y]) && !isNaN(parseInt(value[y])) && w.mapping[key] && (w.mapping[key].dataType === 'date' || key.indexOf('Date') >= 0)) {
                                let dateval = Math.round((value[y] - 25568) * 86400 * 1000)
                                let date = new Date(Date.UTC(0, 0, parseInt(value[y]), -17));
                                let formattedDate = ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear()
                                if (date.getFullYear() == '1969') {
                                    value[y] = null
                                } else {
                                    value[y] = date.toISOString()
                                }
                            }
                            row[key] = value[y];
                            if (this.gqlmap === 'excavation') {
                                if (citation[y]) {
                                    let source = citation[y]
                                    sources[key] = source
                                }
                            }
                        })
                        row.system_modified = true;
                        row.system_inserted = true;
                        if (this.gqlmap == "aacpVi" || this.gqlmap == "aafliii" || this.gqlmap == "ivoryIv" || this.gqlmap == "MDIv") {
                            var itemdata = w.splitdata.filter(function(item) {
                                return item["iLevel Deal Name"] == data["Deal"]
                            });

                            row.BalancedCKG = w.handleNegetiveValue(w.getCellFormattedValue(row.FRBBalancedCKG));;
                            row.CoInvestCKG = '0';

                            if (row.Deal == "Transfer between Balance" || row.Deal == "Co-Investment Checking") {
                                row.FRBBalancedCKG = w.handleNegetiveValue(w.getCellFormattedValue(row.FRBCoInvestCKG));
                                row.CoInvestCKG = '0';
                                row.BalancedCKG = '0';
                            }

                            if (itemdata && itemdata.length > 0) {
                                var total = itemdata.map(item => item["Deal Commitment"]).reduce((a, c) => {
                                    return a + c
                                });
                                itemdata.forEach(element => {
                                    const newValue = w.getCellFormattedValue(row.FRBBalancedCKG.replace(/,/g, ''));
                                    if (element["Tranche II"]) {
                                        row.FRBTranchII = '0';
                                        row.TranchIICKG = w.handleNegetiveValue(event.newValue.toString().replace("(", "-").replace(")", ""));
                                        const preFRBTranchII = (w.rowData.length > 0) ? w.getCellFormattedValue(w.rowData(w.rowData.length - 1).FRBTranchII) : 0;
                                        row.RunningFRBTranchII = w.handleNegetiveValue(parseFloat(parseFloat(preFRBTranchII + w.getCellFormattedValue(row.FRBTranchII)).toFixed(2)));
                                        const preTranchIICKG = (w.rowData.length > 0) ? w.getCellFormattedValue(w.rowData(w.rowData.length - 1).TranchIICKG) : 0;
                                        row.RunningTranchIICKG = w.handleNegetiveValue(parseFloat(parseFloat(preTranchIICKG + w.getCellFormattedValue(row.TranchIICKG)).toFixed(2)));
                                        row.FRBBalancedCKG = '0';
                                    } else {
                                        if (element["Co-Investment Deal"]) {
                                            var p1 = ((element["Deal Commitment"] / total) * 100).toFixed(2);
                                            row.CoInvestCKG = w.handleNegetiveValue(parseFloat(newValue * p1 / 100).toFixed(2));
                                        } else {
                                            var p2 = ((element["Deal Commitment"] / total) * 100).toFixed(2);
                                            row.BalancedCKG = w.handleNegetiveValue(parseFloat(newValue * p2 / 100).toFixed(2));
                                        }
                                    }
                                });
                            }
                            if (w.gqlmap == "aacpVi") {
                                var noMMA = w.getCellFormattedValue(row.NoMMA);
                                let cKG = w.getCellFormattedValue(row.BalancedCKG);
                                row.Total = w.handleNegetiveValue(noMMA + cKG);

                                var getCKGBalance = w.rowData.length > 0 ? w.getCellFormattedValue(w.rowData[w.rowData.length - 1].CKGBalance) : 0;
                                row.CKGBalance = w.handleNegetiveValue(parseFloat(parseFloat(getCKGBalance + cKG).toFixed(2)));
                            } else {
                                var calcFRBBalancedCKG = w.getCellFormattedValue(row.FRBBalancedCKG);
                                var balanceMMA = w.getCellFormattedValue(row.BalancedMMA);
                                var coInvestMMA = w.getCellFormattedValue(row.CoInvestMMA);
                                var fRBCoInvestCKG = w.getCellFormattedValue(row.FRBCoInvestCKG);
                                row.Total = w.handleNegetiveValue(parseFloat(parseFloat(balanceMMA + coInvestMMA + calcFRBBalancedCKG + fRBCoInvestCKG).toFixed(2)));

                                var calcBalancedCKG = w.getCellFormattedValue(row.BalancedCKG)
                                var getCKGBalance = w.rowData.length > 0 ? w.getCellFormattedValue(w.rowData[w.rowData.length - 1].CKGBalance) : 0;
                                row.CKGBalance = w.handleNegetiveValue(parseFloat(parseFloat(getCKGBalance + calcBalancedCKG).toFixed(2)));

                                var getRunningFRBBalCKG = w.rowData.length > 0 ? w.getCellFormattedValue(w.rowData[w.rowData.length - 1].RunningFRBBalCKG) : 0;
                                var getFRBBalancedCKG = w.getCellFormattedValue(row.FRBBalancedCKG);
                                row.RunningFRBBalCKG = w.handleNegetiveValue(parseFloat(parseFloat(getRunningFRBBalCKG + getFRBBalancedCKG).toFixed(2)));

                                var getRunningFRBCoCKG = w.rowData.length > 0 ? w.getCellFormattedValue(w.rowData[w.rowData.length - 1].RunningFRBCoCKG) : 0;
                                var getFRBCoInvestCKG = w.getCellFormattedValue(row.FRBCoInvestCKG);
                                row.RunningFRBCoCKG = w.handleNegetiveValue(parseFloat(parseFloat(getRunningFRBCoCKG + getFRBCoInvestCKG).toFixed(2)));

                            }
                            var calcTotal = w.getCellFormattedValue(row.Total)
                            var getCashBalance = w.rowData.length > 0 ? w.getCellFormattedValue(w.rowData[w.rowData.length - 1].CashBalance) : 0;
                            row.CashBalance = w.handleNegetiveValue(parseFloat(calcTotal + getCashBalance).toFixed(2));

                            var calcCoInvestCKG = w.getCellFormattedValue(row.CoInvestCKG)
                            var getCoInvestCKGBalance = w.rowData.length > 0 ? w.getCellFormattedValue(w.rowData[w.rowData.length - 1].CoInvestCKGBalance) : 0;
                            row.CoInvestCKGBalance = w.handleNegetiveValue(parseFloat(parseFloat(getCoInvestCKGBalance + calcCoInvestCKG).toFixed(2)));

                            var cashBalance = w.getCellFormattedValue(row.CashBalance);
                            var todayDate = w.$moment.utc(new Date());
                            var wireDate = w.$moment.utc(row.WireDate)
                            var dateDiff = todayDate.diff(wireDate, 'days');
                            var calculatedBalancedCKG = w.getCalculatedPrecashBalanceOnLoad(w.rowData);
                            let balancedCKG = w.getCellFormattedValue(row.BalancedCKG);
                            var absBalancedCKG = Math.abs(balancedCKG);
                            if ((dateDiff - 2 <= 1) && (calculatedBalancedCKG <= 0) && (getCashBalance > absBalancedCKG)) {
                                row.AutomatedComments = 'Transfer cash now';
                            } else if (cashBalance <= 0) {
                                row.AutomatedComments = 'Call capital now';
                            } else {
                                row.AutomatedComments = '';
                            }

                        }
                        console.log("loadsheet", row);
                        rows.push(row)
                        data = row;
                        let index = w.series.findIndex(y => y[w.keyfield] == data[w.keyfield])
                        if (index >= 0 || !data[w.keyfield]) {
                            if (index >= 0) {
                                this.$modal.show('dialog', {
                                    title: 'Duplicate detected',
                                    text: `This ${reversemap[w.keyfield]} appears to already exist<br>Please verify and retry`,
                                    class: 'failure'
                                })
                            } else {
                                this.$modal.show('dialog', {
                                    title: 'Deal ID required',
                                    text: `This ${reversemap[w.keyfield]} appears to be missing, please enter a Deal ID and retry`,
                                    class: 'failure'
                                })
                            }
                            this.filereader = Date.now()
                        } else {
                            let user = this.$store.getters.get('user')
                            user = user && user.username ? user.username : 'unknown'
                            let name = data[w.keyfield]
                            Object.keys(data).map((x, i) => {
                                if (x != w.keyfield) {
                                    let index = fields.findIndex(y => y == x)
                                    let event = {
                                        oldValue: '',
                                        newValue: data[x],
                                        colDef: {
                                            headerName: columns[index]
                                        }
                                    }
                                    let change = `<p class='dialog-text'>${name} > ${event.colDef.headerName}<br/><i style='color:brown'>${event.oldValue ? event.oldValue : 'Empty'}</i><br/><i style='color:#016e99'>${event.newValue}</i></p>`
                                    let audit = {
                                        user: user,
                                        key: data[w.keyfield],
                                        old: event.oldValue ? event.oldValue : 'Empty',
                                        new: event.newValue,
                                        timestamp: Date.now()
                                    }
                                    if (w.sheetChanges.findIndex(x => x === change) < 0) {
                                        w.sheetChanges.push(change)
                                        w.auditLog.push(audit)
                                        w.sheetChanged = true;
                                    }
                                }
                            })
                            if (w.dataChanges.findIndex(x => x[w.keyfield] == data[w.keyfield]) >= 0) {
                                w.dataChanges.splice(w.dataChanges.findIndex(x => x[w.keyfield] == data[w.keyfield]), 1)
                            }
                            if (Object.keys(sources).length > 1) {
                                sources.dataType = 'citation'
                                w.dataChanges.push(sources)
                            }

                            w.rowData.push(row);
                            w.dataChanges.push(row)
                            console.log("afterload:::", w.rowData);
                            this.spinner2 = false;
                            if (rows.length > 0) {
                                if (Object.keys(sources).length > 0) w.citations[row.DealID] = sources
                                if (this.gqlmap == "aacpVi" || this.gqlmap == "aafliii" || this.gqlmap == "ivoryIv" || this.gqlmap == "MDIv") {
                                    w.series = w.series.concat(rows);
                                } else {
                                    w.series = rows.concat(w.series);
                                }
                            }
                            this.filereader = Date.now()
                        }
                    }
                }
            } catch (err) {
                this.filereader = Date.now()
                console.log(err)
                this.$modal.show('dialog', {
                    title: 'Error!',
                    text: err,
                    class: 'failure'
                })
                this.spinner2 = false;
            }
        },
        renderPercent: function(value) {
            value.value = parseFloat(value.value) < 0 ? 0 : parseFloat(value.value) > 100 ? 100 : value.value
            return value.value ? 100 * parseFloat(value.value) + '%' : null
        },
        onFilterChanged(ev) {
            let w = this;
            this.drawersorted = Date.now()
            if (ev && ev.api && ev.api.rowModel && ev.api.rowModel.rowsToDisplay) {
                w.setFilter = {
                    selectedRows: ev.api.rowModel.rowsToDisplay
                };
            }
        },
        saveChanges() {
            let ok = [{
                title: 'OK',
                default: true,
                handler: () => {
                    this.$modal.hide('dialog');
                }
            }]
            let buttons = [{
                    title: 'Update',
                    handler: () => {
                        let data = JSON.parse(JSON.stringify(this.dataChanges));
                        data.map(x => {
                            delete x.rowIndex;
                            if (x.dataType === 'citation' && x.__typename === 'hasuraExcavationCitations') {
                                console.log('update citation', x)
                                this.upsertSQLDataCitation(x);
                            } else if (x.dataType === 'citation') {
                                console.log('insert citation', x)
                                this.insertSQlDataCitation(x);
                            } else if (x.system_inserted) {
                                console.log('insert data', x)
                                this.insertSQLData(x);
                            } else {
                                console.log('update data', x)
                                this.upsertSQLData(x);
                            }
                        })

                        this.$modal.hide('dialog');
                    }
                },
                {
                    title: 'Cancel',
                    default: true,
                    handler: () => {
                        this.$modal.hide('dialog');
                    }
                }
            ]
            this.$modal.show('dialog', {
                title: 'Apply Changes?',
                width: '600px',
                maxHeight: '600px',
                text: this.sheetChanges.join('<br/>'),
                class: 'sheet-changes',
                buttons: buttons
            })
        },
        getDatePickerUI() {
            function Datepicker() {}
            Datepicker.prototype.init = function(params) {
                this.eInput = document.createElement("input");
                this.eInput.value = params.value;
                $(this.eInput).datepicker({
                    dateFormat: "dd/mm/yy",
                    onSelect: function(dateText, inst) {
                        params.stopEditing();
                    }
                });
            };
            Datepicker.prototype.getGui = function() {
                return this.eInput;
            };
            Datepicker.prototype.afterGuiAttached = function() {
                this.eInput.focus();
                this.eInput.select();
            };
            Datepicker.prototype.getValue = function() {
                return this.eInput.value;
            };
            Datepicker.prototype.destroy = function() {};
            Datepicker.prototype.isPopup = function() {
                return true;
            };
            return Datepicker;
        },
        loadTextFromFile(ev) {
            const file = ev.target.files[0];
            const reader = new FileReader();

            reader.onload = e => this.$emit("load", e.target.result);
            reader.readAsText(file);
        },
        exportData: function(event) {
            this.writeSheet()
        },
        onSortChangedEvent(event) {
            this.drawersorted = Date.now()
        },
        writeSheet() {
            let w = this;
            this.spinner2 = true;
            if (this.rowData) {
                let name = `${this.$route.name}.export.${this.customDateFormat}.xlsx`
                let csvdata = this.gridOptions.api.getDataAsCsv({
                    allColumns: true
                })
                csvdata = csvdata.split('\r\n')
                csvdata.shift()
                csvdata = csvdata.map(x => x.split(','))
                let data = []
                w.gridApi.forEachNodeAfterFilter(node => {
                    data.push(node.data);
                });
                console.log(data.length);
                data = data.map(x => x.data ? x.data : x)
                var rows = [];
                var columns = this.columnDefs.map(x => x.headerName)
                var fields = this.columnDefs.map(x => x.field)
                let numeric = ["BalancedCKG", "CoInvestCKG", "Total", "CashBalance", "CKGBalance", "CoInvestCKGBalancea", "RunningFRBBalCKG", "RunningFRBCoCKG", "CashBalance", "RunningFRBBalCKG", "RunningFRBCoCKG", "FRBBalancedTotal", "FRBCoInvestTotal", "FRBBalancedCKG", "FRBCoInvestCKG", "CoInvestCKGBalance"]
                rows.push(columns);
                data.forEach(function(p, n) {
                    var result = []
                    fields.map(x => result.push(p[x]))
                    result = result.map((x, i) => {
                        if (numeric.indexOf(w.columnDefs[i].field) >= 0) {
                            return w.getCellFormattedValue(x);
                        } else {
                            return x
                        }
                    })
                    rows.push(result)
                })
                var headers = {}
                this.columnDefs.map(x => {
                    headers[x.field] = x.headerName
                })
                let wscols = this.columnDefs.map(x => {
                    return {
                        wch: x.headerName.length + 4
                    }
                })
                var sheethtml = new Table({
                    'class': 'tableHTML'
                }).setHeaders(headers).setData(data).render()
                var wb = XLSX.utils.book_new();
                var ws = XLSX.utils.aoa_to_sheet(rows);
                const range = XLSX.utils.decode_range(ws["!ref"]);
                const rowCount = range.e.r;
                const columnCount = range.e.c;
                for (let row = 0; row <= rowCount; row++) {
                    for (let col = 0; col <= columnCount; col++) {
                        const cellRef = XLSX.utils.encode_cell({
                            r: row,
                            c: col
                        });
                        let header = this.columnDefs[col].field
                        let mapping = this.mapping[header]
                        let format = mapping.format
                        if (row == 0) {
                            ws[cellRef].s = {
                                font: {
                                    bold: true
                                },
                                alignment: {
                                    horizontal: "center"
                                }
                            }
                        }
                        if (row > 0 && ws[cellRef] && (ws[cellRef].v || ws[cellRef].v == 0)) {
                            if (format == 'numeric') {
                                ws[cellRef].s = {
                                    numFmt: '#,##0.00;[Red]\-#,##0.00'
                                }
                            }
                        }
                        if (format == 'date' && row > 0) {
                            let value = ws[cellRef] && ws[cellRef].v ? ws[cellRef].v : false
                            try {
                                if (ws[cellRef] && ws[cellRef].v) {
                                    ws[cellRef].v = w.$moment.utc(ws[cellRef].v).format("L")
                                }
                                if (ws[cellRef]) {
                                    ws[cellRef].s = {
                                        numFmt: "mm/dd/yy",
                                        alignment: {
                                            horizontal: "center"
                                        }
                                    }
                                }
                            } catch (err) {
                                if (value) ws[cellRef].v = value
                            }
                            if (value && ws[cellRef] && ws[cellRef].v && ws[cellRef].v.toLowerCase().includes('invalid date')) ws[cellRef].v = value
                        }
                        if (ws[cellRef] && (ws[cellRef].v || ws[cellRef].v == 0)) {
                            let width = ws[cellRef].v.toString().length
                            wscols[col].wch = wscols[col].wch >= width + 4 ? wscols[col].wch : width + 4
                        }
                    }
                }
                ws['!cols'] = wscols;
                XLSX.utils.book_append_sheet(wb, ws, "table");
                XLSX.writeFile(wb, name, {
                    compression: true,
                    cellStyles: true
                });
            } else {
                console.log('Nothing to export..')
            }
            this.spinner2 = false;
        },
        writeSheet2() {
            this.spinner2 = true;
            if (this.rowData) {

                let name = `${this.$route.name}.export.${this.customDateFormat}.xlsx`
                var data = this.setFilter && this.setFilter.selectedRows && this.setFilter.selectedRows.length > 0 ? this.setFilter.selectedRows : this.rowData;
                data = this.gridOptions.api.getRenderedNodes()
                data = data.map(x => x.data ? x.data : x)
                var rows = [];
                var columns = this.columnDefs.map(x => x.headerName)
                var fields = this.columnDefs.map(x => x.field)
                rows.push(columns);
                data.forEach(function(p) {
                    var result = []
                    fields.map(x => result.push(p[x]))
                    rows.push(result)
                })
                var headers = {}
                this.columnDefs.map(x => {
                    headers[x.field] = x.headerName
                })
                var sheethtml = new Table({
                    'class': 'tableHTML'
                }).setHeaders(headers).setData(data).render()
                var wb = XLSX.utils.book_new();
                var ws = XLSX.utils.aoa_to_sheet(rows);
                XLSX.utils.book_append_sheet(wb, ws, "table");
                XLSX.writeFile(wb, name, {
                    compression: true
                });
            } else {
                console.log('Nothing to export..')
            }
            this.spinner2 = false;
        },
        onDragStopped() {
            var headers = [];
            var columns = this.gridOptions.columnApi.getAllGridColumns()
            columns.forEach((col, i) => {
                if (col.colDef.field !== 'sample' && col.colDef.field !== 'distance') {
                    headers.push(col.colDef.field)
                }
            })
            this.$store.commit('change', {
                g25chartComponents: headers
            })
            this.components = headers;
            var series = this.series;
            var result = []
            headers.forEach(component => {
                result.push(series.find(item => item.name === component))
            })
            this.$store.commit('change', {
                g25chartSeries: result
            })
        },
        paginationChanged: function(event) {
            this.gridApi = this.gridOptions.api;
            this.gridApi.flashCells({
                rowNodes: this.rowsupdated
            })
        },
        onCellEditingStopped: function(event) {},
        onRowEditingStopped: function(event) {
            console.log("on row editing stopped");
        },
        onCellEditingStarted: function(event) {
            let w = this;
            const savedState = w.gridOptions.columnApi.getColumnState();
            const filterState = w.gridOptions.api.getFilterModel();
            w.savedState = savedState;
            w.filterState = filterState;
        },
        isLetter(str) {
            var regexp = /[A-Za-z_/-]/i;
            return regexp.exec(str);
        },
        onCellValueChanged: function(event) {
            console.log("event2::::", event.oldValue, event.newValue);
            event.newValue = typeof(event.newValue) == 'object' ? event.newValue.label : (event.newValue || event.newValue == "" || event.newValue == null) ? event.newValue : event.oldValue
            let w = this;
            if (event.oldValue !== event.newValue) {
                let data = event.data
                data.rowIndex = event.rowIndex
                let rowNode = event.node
                let column = event.column.colId;
                console.log('column', column, data)
                data[column] = (((this.gqlmap === 'aacpVi' || this.gqlmap === 'aafliii' || this.gqlmap === 'ivoryIv' || this.gqlmap === 'MDIv') && this.isLetter(event.newValue) === null) && event.newValue.toString() != "") ? w.handleNegetiveValue(event.newValue) : event.newValue;
                console.log(data[column])


                if (column == "Deal") {
                    console.log('editing')
                    setTimeout(() => {
                        w.gridApi.startEditingCell({
                            rowIndex: event.rowIndex,
                            colKey: 'FRBBalancedCKG'
                        })
                        let input = document.querySelectorAll('input.my-simple-editor')
                        if (input && input[0]) {
                            input[0].select();
                        }
                    }, 100)
                }

                if (column == "BalancedCKG") {
                    console.log('BalancedCKG', event.newValue)
                    var balanceCKG = w.getCellFormattedValue(event.newValue);
                    var fRBBalance = w.getCellFormattedValue(data["FRBBalancedCKG"]) || balanceCKG;
                    if (!fRBBalance) {
                        var itemdata = w.splitdata.filter(function(item) {
                            return item["iLevel Deal Name"] == data.Deal
                        });
                        itemdata.forEach(element => {
                            const newValue = fRBBalance
                            if (!element["Co-Investment Deal"]) {
                                var p2 = ((element["Deal Commitment"] / total) * 100).toFixed(2);
                                balanceCKG = w.handleNegetiveValue(parseFloat(newValue * p2 / 100).toFixed(2));
                            }
                        });
                    }
                    data["CoSplit"] = parseFloat(parseFloat(fRBBalance - balanceCKG + 0.00000001).toFixed(2));
                }
                if (column == "CoInvestCKG") {
                    var coInvestCKG = w.getCellFormattedValue(event.newValue);
                    var fRBBalance = w.getCellFormattedValue(data["FRBBalancedCKG"]);
                    data["BalancedCKG"] = parseFloat(parseFloat(fRBBalance - coInvestCKG).toFixed(2));
                    data["BalSplit"] = parseFloat(parseFloat(fRBBalance - coInvestCKG).toFixed(2));
                    var calcCoInvestCKG = coInvestCKG;
                    var getCoInvestCKGBalance = (rowIndex > 0) ? w.getCellFormattedValue(data.api.getRowNode(rowIndex - 1).data.CoInvestCKGBalance) : 0;
                    data["CoInvestCKGBalance"] = (parseFloat(parseFloat(getCoInvestCKGBalance + calcCoInvestCKG).toFixed(2)));

                }

                if (column == "FRBCoInvestCKG") {
                    if (data["Deal"] == "Transfer between Balance" || data["Deal"] == "Co-Investment Checking") {
                        data["FRBBalancedCKG"] = (-1 * w.getCellFormattedValue(event.newValue));
                        data["CoInvestCKG"] = 0;
                        data["BalancedCKG"] = 0;
                        data["FRBCoInvestCKG"] = (event.newValue.toString().replace("(", "-").replace(")", ""));
                    } else {
                        data["CoInvestCKG"] = data.FRBCoInvestCKG
                        data["CoSplit"] = data.FRBCoInvestCKG
                    }
                }

                if (column == "FRBTranchII") {
                    data["FRBTranchII"] = w.handleNegetiveValue(event.newValue.toString().replace("(", "-").replace(")", ""));
                    const preFRBTranchII = (rowIndex > 0) ? w.getCellFormattedValue(event.api.getRowNode(rowIndex - 1).data.FRBTranchII) : 0;
                    data["RunningFRBTranchII"] = w.handleNegetiveValue(parseFloat(parseFloat(preFRBTranchII + w.getCellFormattedValue(data["FRBTranchII"])).toFixed(2)));

                }

                if (column == "TranchIICKG") {
                    data["TranchIICKG"] = w.handleNegetiveValue(event.newValue.toString().replace("(", "-").replace(")", ""));
                    const preTranchIICKG = (rowIndex > 0) ? w.getCellFormattedValue(event.api.getRowNode(rowIndex - 1).data.TranchIICKG) : 0;
                    data["RunningTranchIICKG"] = w.handleNegetiveValue(parseFloat(parseFloat(preTranchIICKG + w.getCellFormattedValue(data["TranchIICKG"])).toFixed(2)));

                }

                if (column == "FRBCoInvestCKG") {
                    var getRunningFRBCoCKG = rowIndex > 0 ? w.getCellFormattedValue(event.api.getRowNode(rowIndex - 1).data.RunningFRBCoCKG) : 0;
                    var getFRBCoInvestCKG = w.getCellFormattedValue(data["FRBCoInvestCKG"]);
                    data["RunningFRBCoCKG"] = (parseFloat(parseFloat(getRunningFRBCoCKG + getFRBCoInvestCKG).toFixed(2)));

                }

                if (column == "FRBBalancedCKG") {
                    if (data.Deal.toLowerCase().substr(0, 5) == 'cash ') {
                        if (typeof(event.newValue) == 'string') {
                            data.CoSplit = w.handleNegetiveValue(((event.newValue.includes('(') ? 1 : -1) * event.newValue.replace(/,/g, '').replace(/\(/, '').replace(/\)/, '')).toFixed(2));
                        } else {
                            data.CoSplit = -1 * event.newValue
                        }
                    } else {
                        data.FRBCoInvestCKG = 0;
                        var rowIndex = event.rowIndex; //parseFloat(data.node.id)
                        var itemdata = w.splitdata.filter(function(item) {
                            return item["iLevel Deal Name"] == data["Deal"]
                        });
                        data["CoInvestCKG"] = 0;
                        data["BalancedCKG"] = 0;
                        data["FRBBalancedCKG"] = parseFloat(w.getCellFormattedValue(event.newValue));
                        if (itemdata && itemdata.length === 0) {
                            data["BalancedCKG"] = data["FRBBalancedCKG"]
                            data["BalSplit"] = data["FRBBalancedCKG"]
                        } else {
                            var total = itemdata.map(item => item["Deal Commitment"]).reduce((a, c) => {
                                console.log(3, data)
                                return a + c
                            });
                            itemdata.forEach(element => {
                                const newValue = w.getCellFormattedValue(event.newValue.replace(/,/g, ''));
                                if (element["Tranche II"]) {
                                    data["FRBTranchII"] = '0';
                                    data["TranchIICKG"] = w.handleNegetiveValue(event.newValue.toString().replace("(", "-").replace(")", ""));
                                    const preFRBTranchII = (rowIndex > 0) ? w.getCellFormattedValue(event.api.getRowNode(rowIndex - 1).data.FRBTranchII) : 0;
                                    data["RunningFRBTranchII"] = w.handleNegetiveValue(parseFloat(parseFloat(preFRBTranchII + w.getCellFormattedValue(data["FRBTranchII"])).toFixed(2)));
                                    const preTranchIICKG = (rowIndex > 0) ? w.getCellFormattedValue(event.api.getRowNode(rowIndex - 1).data.TranchIICKG) : 0;
                                    data["RunningTranchIICKG"] = w.handleNegetiveValue(parseFloat(parseFloat(preTranchIICKG + w.getCellFormattedValue(data["TranchIICKG"])).toFixed(2)));
                                    data["FRBBalancedCKG"] = '0';
                                } else {
                                    if (element["Co-Investment Deal"]) {
                                        var p1 = parseFloat(((element["Deal Commitment"] / total) * 100).toFixed(2));
                                        data["CoInvestCKG"] = parseFloat((newValue * p1 / 100).toFixed(2))
                                        data["CoSplit"] = parseFloat((newValue * p1 / 100).toFixed(2))
                                    } else {
                                        var p2 = parseFloat(((element["Deal Commitment"] / total) * 100).toFixed(2));
                                        data["BalancedCKG"] = parseFloat((newValue * p2 / 100).toFixed(2));
                                        data["BalSplit"] = parseFloat((newValue * p2 / 100).toFixed(2));
                                    }
                                    console.log(4, data)
                                }
                            });
                        }
                    }



                    if (w.gqlmap == "aacpVi") {
                        var noMMA = w.getCellFormattedValue(data["NoMMA"]);
                        var cKG = w.getCellFormattedValue(data["BalancedCKG"]);
                        data["Total"] = w.handleNegetiveValue(noMMA + cKG);

                        var calcCKG = w.getCellFormattedValue(data["CKG"]);
                        var getCKGBalance = (rowIndex > 0) ? w.getCellFormattedValue(event.api.getRowNode(rowIndex - 1).data.CKGBalance) : 0;
                        data["CKGBalance"] = w.handleNegetiveValue(parseFloat(parseFloat(getCKGBalance + calcCKG).toFixed(2)));
                    } else {
                        var calcFRBBalancedCKG = w.getCellFormattedValue(data["FRBBalancedCKG"])
                        var balanceMMA = w.getCellFormattedValue(data["BalancedMMA"]);
                        var coInvestMMA = w.getCellFormattedValue(data["CoInvestMMA"]);
                        var fRBCoInvestCKG = w.getCellFormattedValue(data["FRBCoInvestCKG"]);
                        data["Total"] = w.handleNegetiveValue(parseFloat(parseFloat(balanceMMA + coInvestMMA + calcFRBBalancedCKG + fRBCoInvestCKG).toFixed(2)));


                        var calcBalancedCKG = w.getCellFormattedValue(data["BalancedCKG"])
                        var getCKGBalance = (rowIndex > 0) ? w.getCellFormattedValue(event.api.getRowNode(rowIndex - 1).data.CKGBalance) : 0;
                        data["CKGBalance"] = w.handleNegetiveValue(parseFloat(parseFloat(getCKGBalance + calcBalancedCKG).toFixed(2)));

                        var getRunningFRBBalCKG = rowIndex > 0 ? w.getCellFormattedValue(event.api.getRowNode(rowIndex - 1).data.RunningFRBBalCKG) : 0;
                        var getFRBBalancedCKG = w.getCellFormattedValue(data["FRBBalancedCKG"]);
                        data["RunningFRBBalCKG"] = w.handleNegetiveValue(parseFloat(parseFloat(getRunningFRBBalCKG + getFRBBalancedCKG).toFixed(2)));


                    }


                    var calcTotal = w.getCellFormattedValue(data["Total"])
                    var getCashBalance = (rowIndex > 0) ? w.getCellFormattedValue(event.api.getRowNode(rowIndex - 1).data.CashBalance) : 0;

                    data["CashBalance"] = w.handleNegetiveValue(parseFloat(parseFloat(getCashBalance + calcTotal).toFixed(2)));

                    var calcCoInvestCKG = w.getCellFormattedValue(data["CoInvestCKG"])
                    var getCoInvestCKGBalance = (rowIndex > 0) ? w.getCellFormattedValue(event.api.getRowNode(rowIndex - 1).data.CoInvestCKGBalance) : 0;
                    data["CoInvestCKGBalance"] = w.handleNegetiveValue(parseFloat(parseFloat(getCoInvestCKGBalance + calcCoInvestCKG).toFixed(2)));

                    var cashBalance = w.getCellFormattedValue(data["CashBalance"]);
                    var todayDate = w.$moment.utc(new Date());
                    var wireDate = w.$moment.utc(data["WireDate"])
                    var dateDiff = todayDate.diff(wireDate, 'days');
                    var calculatedBalancedCKG = w.getCalculatedPrecashBalanceFromEvent(data, event);
                    var balancedCKG = w.getCellFormattedValue(data["BalancedCKG"]);
                    var absBalancedCKG = Math.abs(balancedCKG);
                    if ((dateDiff - 2 <= 1) && (calculatedBalancedCKG <= 0) && (getCashBalance > absBalancedCKG)) {
                        data["AutomatedComments"] = 'Transfer cash now';
                    } else if (cashBalance <= 0) {
                        data["AutomatedComments"] = 'Call capital now';
                    } else {
                        data["AutomatedComments"] = '';
                    }
                }
                w.gridApi.redrawRows(event);
                if (w.rowsupdated.findIndex(x => x.rowIndex == rowNode.rowIndex) < 0) {
                    w.rowsupdated.push(rowNode);
                }
                event.api.flashCells({
                    rowNodes: w.rowsupdated
                })
                let user = this.$store.getters.get('user')
                user = user && user.username ? user.username : 'unknown';
                let name = event.data.DealID ? event.data.DealID : (event.data.Id ? event.data.Id + '-' + event.data.Deal : event.data.CompanyName);
                let change = `<p class='dialog-text'>${name} > ${event.colDef.headerName}<br/><i style='color:brown'>${event.oldValue ? event.oldValue : 'Empty'}</i><br/><i style='color:#016e99'>${event.newValue}</i></p>`
                let audit = {
                    user: user,
                    key: data[this.keyfield],
                    old: event.oldValue ? event.oldValue : 'Empty',
                    new: event.newValue,
                    timestamp: Date.now()
                }
                if (this.sheetChanges.findIndex(x => x === change) < 0) {
                    if (this.dataChanges.findIndex(x => x.rowIndex == data.rowIndex) >= 0) this.dataChanges.splice(this.dataChanges.findIndex(x => x.rowIndex == data.rowIndex), 1)
                    this.dataChanges.push(data)
                    this.sheetChanges.push(change)
                    this.auditLog.push(audit)
                    this.sheetChanged = true;
                }
                w.refreshSave++
            } else {
                let edata = event.data
                let ecolumn = event.column.colId;
                if (ecolumn == "FRBBalancedCKG" && !edata.Deal.toLowerCase().substr(0, 5) == 'cash ') {
                    edata.FRBCoInvestCKG = 0;
                    console.log(222, edata);
                }
                w.refreshSave++
                let data = event.data
                data.rowIndex = event.rowIndex
                let rowNode = event.node
                let column = event.column.colId;
                data[column] = (((this.gqlmap === 'aacpVi' || this.gqlmap === 'aafliii' || this.gqlmap === 'ivoryIv' || this.gqlmap === 'MDIv') && this.isLetter(event.newValue) === null) && event.newValue.toString() != "") ? w.handleNegetiveValue(event.newValue) : event.newValue;
                console.log(123, event)
            }
            if (!w.drawer) {
                setTimeout(() => {
                    if (w.filterState) {
                        w.gridOptions.api.setFilterModel(w.filterState);
                    }
                }, 0)
            }

        },
        onCellDblClicked(evt) {
            let w = this;
            if (evt.colDef && !evt.colDef.editable) {
                const savedState = w.gridOptions.columnApi.getColumnState();
                const filterState = w.gridOptions.api.getFilterModel();
                w.savedState = savedState;
                w.filterState = filterState;
                this.currentRow = evt.rowIndex;
                this.gridOptions.api.doLayout();
                this.filteredData = this.setFilter && this.setFilter.selectedRows && this.setFilter.selectedRows.length > 0 ? this.setFilter.selectedRows.map(x => x.data) : this.rowData ? this.rowData : []
                let model = w.gridOptions.api.getModel()
                let sort = []
                let sortmodel = w.gridOptions.api.getSortModel()[0]
                if (sortmodel != w.sortmodel) {
                    if (model && model.rowsToDisplay && model.rowsToDisplay[0] && model.rowsToDisplay[0].data && model.rowsToDisplay[0].data[w.keyfield]) {
                        model.rowsToDisplay.map(x => {
                            sort.push(x.data[w.keyfield])
                        })
                        const sorter = function(a, b) {
                            return sort.indexOf(a[w.keyfield]) - sort.indexOf(b[w.keyfield])
                        }
                        if (sort.length > 0) {
                            w.filteredData.sort(sorter);
                        }
                        this.drawersorted = Date.now();
                        w.sortmodel = sortmodel
                    }
                }
                setTimeout(() => {
                    this.drawer = true;
                    setTimeout(() => {
                        if (this.$refs.carousel && this.$refs.carousel.swiper) this.$refs.carousel.swiper.slideTo(evt.rowIndex, 0)
                    }, 0)
                }, 10)
            }
        },
        onRowDblClicked(evt) {},
        onSelectionChanged() {
            this.gridApi = this.gridOptions.api;
            var selectedRows = this.gridApi.getSelectedRows();
            if (selectedRows.length > 0) {
                this.rowsSelected = true;
                if (this.gqlmap === 'excavation' || this.gqlmap === 'entitydb' || this.gqlmap === 'entitydbCd' || this.gqlmap === 'entitydbLa' || this.gqlmap === 'entitydbRt' || this.gqlmap === 'aacpVi' || this.gqlmap === 'aafliii' || this.gqlmap === 'MDIv' || this.gqlmap === 'odd') this.deleteRows = true;
                if (this.gqlmap === 'ivoryIv') {
                    if (this.gridApi.getSelectedRows().filter(x => x.Id > 16680563506).length > 0) {
                        this.deleteRows = false
                    } else {
                        this.deleteRows = true
                    }
                }
            } else {
                this.rowsSelected = false;
                this.deleteRows = false;
            }
        },
        addEntity: function(event) {
            let w = this;
            let rowindex = w.rowData.length
            const data = w.rowData;
            const newRow = data[0]

            let newData = {};
            Object.keys(newRow).forEach(key => {
                if (key == "Id") {
                    newData[key] = Date.now();
                } else {
                    newData[key] = null;
                }
            });
            newData.system_inserted = true;
            w.rowData.push(newData);
            this.gridApi = this.gridOptions.api;
            if (this.gqlmap === 'excavation' || this.gqlmap === 'entitydb' || this.gqlmap === 'entitydbCd' || this.gqlmap === 'entitydbLa' || this.gqlmap === 'entitydbRt' || this.gqlmap === "odd") {
                this.gridApi.applyTransaction({
                    add: [{
                        system_inserted: true
                    }],
                    addIndex: 0
                });
            } else if (this.gqlmap === 'aacpVi' || this.gqlmap === 'aafliii' || this.gqlmap === 'ivoryIv' || this.gqlmap === 'MDIv') {
                console.log('adding row at index', w.rowData.length - 1);
                this.gridApi.applyTransaction({
                    add: [newData],
                    addIndex: w.rowData.length - 1
                });
                w.gridApi.paginationGoToPage(parseInt((w.gridApi.getDisplayedRowCount() / w.gridApi.paginationGetPageSize())) + 1)
                w.gridApi.startEditingCell({
                    rowIndex: w.rowData.length - 1,
                    colKey: 'Deal'
                })
                w.sheetChanged = true;
            }
            //this.gridApi.updateRow({add: {}, addIndex: 0})
        },
        setModule: function() {
            let module = (this.$store.getters.get('module'))
            this.module = module;
            let subModule = (this.$store.getters.get('submodule'))
            this.subModule = subModule;
        },
        modelUpdated: function() {},
        gridReady: function() {
            this.gridApi = this.gridOptions.api;
        },
        runQuery: async function(refresh) {
            this.drawersorted = Date.now();
            this.series = []
            this.spinner = true;
            let w = this;
            refresh = refresh ? true : false;
            this.rowsupdated = []
            try {
                w.citations = {}
                this.$store.commit('change', {
                    slideWrapper: 'hidden'
                })
                let gqlmap = (this.$store.getters.get('gqlmap'));
                if (gqlmap) {
                    let gqldata;
                    if (gqlmap == 'excavation') {
                        this.$adal.acquireToken('6e0cdae3-9345-4b51-aa10-8d00a3512389', async (err, token) => {
                            let data = await this.$apollo.query({
                                query: GET_EXCAVATIONS,
                                fetchPolicy: 'network-only'
                            })
                            setTimeout(() => {
                                if (data.data) {
                                    if (Object.keys(data.data).length > 0) {
                                        let q = Object.keys(data.data)[0]
                                        this.series = JSON.parse(JSON.stringify(data.data[q]));
                                        this.$store.commit('change', {
                                            slideWrapper: 'visible'
                                        })
                                    }
                                }
                                this.spinner = false;
                                if (w.gridApi) {
                                    w.gridApi.flashCells({
                                        rowNodes: w.rowsupdated
                                    })
                                }
                            }, 301)

                            if (data.data) {
                                let citations = await this.$apollo.query({
                                    query: GET_EXCAVATIONS_CITATIONS,
                                    id: refresh ? 'citations:' + Date.now() : 'citations:0',
                                    fetchPolicy: refresh ? 'no-cache' : 'network-only'
                                })
                                if (citations && citations.data && Object.keys(citations.data).length > 0) {
                                    let table = Object.keys(citations.data)[0]
                                    let obj = {}
                                    citations.data[table].map(x => {
                                        obj[x.DealID]
                                    })
                                    w.citations = {
                                        ...obj
                                    };
                                }
                                this.spinner = false;
                            }
                        })
                    } else if (gqlmap == 'entitydb' || gqlmap == 'entitydbCd' || gqlmap == 'entitydbLa' || this.gqlmap === 'entitydbRt') {
                        let queryEntity = GET_ENTITYDBS;
                        if (gqlmap == 'entitydbCd') {
                            queryEntity = GET_ENTITYDBS_CD;
                        } else if (gqlmap == 'entitydbLa') {
                            queryEntity = GET_ENTITYDBS_LA;
                        } else if (this.gqlmap === 'entitydbRt') {
                            queryEntity = GET_ENTITYDBS_RT;
                        }
                        this.$adal.acquireToken('6e0cdae3-9345-4b51-aa10-8d00a3512389', async (err, token) => {
                            let data = await this.$apollo.query({
                                query: queryEntity,
                                fetchPolicy: refresh ? 'network-only' : undefined
                            })
                            setTimeout(() => {
                                if (data.data) {
                                    if (Object.keys(data.data).length > 0) {
                                        let q = Object.keys(data.data)[0]
                                        this.series = JSON.parse(JSON.stringify(data.data[q]));
                                        this.$store.commit('change', {
                                            slideWrapper: 'visible'
                                        })
                                    }
                                }
                                this.spinner = false;
                                if (w.gridApi) {
                                    w.gridApi.flashCells({
                                        rowNodes: w.rowsupdated
                                    })
                                }
                            }, 301)
                        })
                    } else if (gqlmap == 'aacpVi' || gqlmap == 'aafliii' || gqlmap == 'ivoryIv' || gqlmap == 'MDIv') {
                        let queryCashManagement = GET_CASH_MANAGEMENT;
                        this.$adal.acquireToken('6e0cdae3-9345-4b51-aa10-8d00a3512389', async (err, token) => {
                            let startdate = this.$store.getters.get('startdate');
                            let date = new Date();
                            if (!startdate) {
                                startdate = new Date(date.getFullYear(), date.getMonth(), 1);
                                startdate = startdate.toISOString()
                            }
                            date = new Date(startdate);
                            let currentMonth = date.getUTCMonth()
                            let currentYear = date.getUTCFullYear()
                            let nextMonth = currentMonth == 11 ? 0 : currentMonth + 1
                            let nextYear = currentMonth == 11 ? currentYear + 1 : currentYear
                            let endDate = new Date(nextYear, nextMonth, 1);
                            endDate.setDate(endDate.getDate() - 1);
                            startdate = startdate.split('T')[0]
                            endDate = endDate.toISOString()
                            endDate = endDate.split('T')[0]
                            console.log('datews', startdate, endDate)
                            if (gqlmap == 'ivoryIv') {
                                let balq = GET_CASH_MANAGEMENT_BALANCE
                                let variables = {
                                    investor: this.fundid,
                                    date: startdate,
                                }
                                let balances = await this.$apollo.query({
                                    query: balq,
                                    variables: variables,
                                    fetchPolicy: 'network-only'
                                })
                                if (balances && balances.data && balances.data.CashManagement_cashManagementBalances) {
                                    this.balances = balances.data.CashManagement_cashManagementBalances[0]
                                } else {
                                    this.balances = false
                                }
                                console.log('balances', variables, this.balances);
                            }
                            let variables = {
                                fundid: this.fundid,
                            }
                            let today = w.$moment.utc(new Date()).format("YYYY-MM-DD")
                            if (gqlmap == 'ivoryIv') {
                                variables.startdate = startdate
                                variables.enddate = this.TCD ? today : endDate
                            }
                            console.log('getting', variables);
                            let data = await this.$apollo.query({
                                query: queryCashManagement,
                                variables: variables,
                                fetchPolicy: refresh ? 'network-only' : undefined
                            })
                            console.log('data', data);
                            setTimeout(() => {
                                if (data.data) {
                                    if (Object.keys(data.data).length > 0) {
                                        let q = Object.keys(data.data)[0]
                                        let rawseries = JSON.parse(JSON.stringify(data.data[q]));
                                        if (rawseries.length == 0) {
                                            let comp = Object.keys(this.mapping)
                                            let modcomp = [];
                                            if (w.gqlmap == "ivoryIv") {
                                                modcomp = []
                                                comp.map(x => {
                                                    if (["Id", "Deal", "WireDate", "BalancedCKG", "CoInvestCKG", "Total", "CashBalance", "CKGBalance", "CoInvestCKGBalance", "AutomatedComments", "TiesToBank", "LOCInterestCommitment"].includes(x) || (x.toLowerCase().includes('frb'))) modcomp.push(x)
                                                })
                                            } else {
                                                modcomp = [...comp];
                                            }
                                            let data = {}
                                            modcomp.map(x => {
                                                data[x] = null
                                            })
                                            rawseries = [data]
                                        }
                                        console.log('rows', rawseries);
                                        let series = []
                                        let seriesobj = {}
                                        rawseries.forEach((row, i) => {
                                            if (!seriesobj[`${row.Deal}:${row.WireDate}-removed`]) {
                                                row.BalSplit = row.BalSplit || 0
                                                row.CoSplit = row.CoSplit || 0
                                                seriesobj[`${row.Deal}:${row.WireDate}`] = row
                                                series.push(row)
                                            } else {
                                                let index = series.findIndex(y => y.Deal == row.Deal && y.WireDate == row.WireDate)
                                                row.BalSplit = row.Vehicle && (row.Vehicle == 'Balanced') ? row.FRBBalancedCKG : series[index].BalSplit
                                                row.CoSplit = row.Vehicle && (row.Vehicle == 'Co-Invest') ? row.FRBBalancedCKG : series[index].CoSplit;
                                                series[index] = row;

                                            }
                                            let ckgbalance = this.balances && this.balances.CkgBalance ? this.balances.CkgBalance : 0
                                            let cobalance = this.balances && this.balances.CoInvestCKGBalance ? this.balances.CoInvestCKGBalance : 0
                                            if (i >= 0) {
                                                ckgbalance = ckgbalance + (row.BalancedCKG ? row.BalancedCKG : 0)
                                                cobalance = cobalance + (row.BalancedCKG ? row.BalancedCKG : 0)
                                            }
                                        })
                                        this.rawseries = series

                                        if (gqlmap == 'ivoryIv' && variables.startdate) {
                                            this.series = this.rawseries.filter(x => x.WireDate == null || new Date(x.WireDate) >= new Date(variables.startdate))
                                            this.startseries = this.rawseries.filter(x => new Date(x.WireDate) < new Date(variables.startdate))
                                        } else {
                                            this.series = this.rawseries
                                        }
                                        this.$store.commit('change', {
                                            slideWrapper: 'visible'
                                        })
                                    }
                                }
                                this.spinner = false;
                                if (w.gridApi) {
                                    w.gridApi.flashCells({
                                        rowNodes: w.rowsupdated
                                    })
                                }
                            }, 301)
                        })
                    } else if (gqlmap == "odd") {
                        let queryOddDb = GET_ODDDBS;

                        this.$adal.acquireToken('6e0cdae3-9345-4b51-aa10-8d00a3512389', async (err, token) => {
                            let data = await this.$apollo.query({
                                query: queryOddDb,
                                fetchPolicy: refresh ? "network-only" : undefined,
                            });
                            setTimeout(() => {
                                if (data.data) {
                                    if (Object.keys(data.data).length > 0) {
                                        let q = Object.keys(data.data)[0];
                                        this.series = JSON.parse(JSON.stringify(data.data[q]));
                                        this.$store.commit("change", {
                                            slideWrapper: "visible",
                                        });
                                    }
                                }
                                this.spinner = false;
                                if (w.gridApi) {
                                    w.gridApi.flashCells({
                                        rowNodes: w.rowsupdated,
                                    });
                                }
                            }, 301);
                        });
                    } else {
                        let data = sqlTables[gqlmap].data
                        setTimeout(() => {
                            if (data.data) {
                                if (Object.keys(data.data).length > 0) {
                                    let q = Object.keys(data.data)[0]
                                    this.series = data.data[q].items;
                                    this.$store.commit('change', {
                                        slideWrapper: 'visible'
                                    })
                                }
                            }
                        }, 301)
                        this.spinner = false;
                    }
                    /*
                this.$apollo.query({
                    query: query,
                    fetchPolicy: 'network-only'
                }).then(data => {
            }).
            catch(err => {
                this.series = []
          this.$store.commit('change', { slideWrapper: 'visible' })
            })
            */
                } else {
                    setTimeout(() => {
                        this.series = []
                        this.$store.commit('change', {
                            slideWrapper: 'visible'
                        })
                    }, 200)
                    this.spinner = false;
                }
            } catch (err) {
                this.spinner = false;
            }
        }
    }
}
